
let aw_dataArray = [];
let aw_insideLink = false;
// aw_printReturnCode -> Quando a true se ricevo returnCode > 0
// stampo anche il valore ad esso assegnato.
// Oltre al messaggio di errore se presente.
let aw_printReturnCode = false;
let aw_jQueryVersion = '3.5.1';
let awJq = jQuery.noConflict(true);
let aw_unsupportedBrowserError = 'The browser you are using is obsolete and incompatible with this page';

/*if (typeof $ == 'undefined') {
    // Esiste una sola versione di jQuery
    $ = awJq;
    jQuery = awJq;
} else {
    // Molteplici versioni di jQuery
    let tempJq;
    if ($.fn.jquery == aw_jQueryVersion) {
        // La versione awJq Ã¨ stata importata prima di quella del sito
        tempJq = awJq;
        awJq = $;
        $ = tempJq;
        jQuery = tempJq
    }
}*/
awJq('document').ready(function () {
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf("MSIE ");
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer
    {
        console.log('Explorer');
        aw_unsupportedBrowser();
    } else  // If another browser
    {
        startSc();
        /* --- Log Utili per controllare le versioni di jquery --- */
        // console.log('Jquery with $: ', $.fn.jquery);
        // console.log('Jquery with awJq: ', awJq.fn.jquery);
        // console.log('Jquery with jQuery: ', jQuery.fn.jquery);
        /* ------------------------------------------------------- */
        // La prima riga del CSS che segue serve per la vsualizzazione corretta del carosello.
        let css = '.aw_vieportcarousel {overflow: hidden;}'
            + ' .aw_jobSlider .aw_jobPosting {width:100%!important}';
        let head = document.head || document.getElementsByTagName('head')[0];
        let style = document.createElement('style');
        style.type = 'text/css';
        if (style.styleSheet) {
            style.styleSheet.cssText = css;
        } else {
            style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
        let script1 = document.createElement('script');
        script1.type = 'text/javascript';
        script1.src = 'https://kit.fontawesome.com/80ccb54cdd.js';
        document.getElementsByTagName('head')[0].appendChild(script1);
    }
});

function aw_unsupportedBrowser() {
    if (aw_insideLink) {
        awJq('a[data-allibo]').on("click", function (event) {
            event.preventDefault();
        });
        awJq('a[data-allibo]').css({ "color": "inherit", "text-decoration": "inherit" });
    }
    awJq('a[data-allibo]').each(function () {
        let href = awJq(this).attr('href');
        let rel = awJq(this).attr('rel');
        let url = awJq(this).attr('data-allibo');
        if (href != 'https://allibo.com' || rel != 'follow' || url == null || url == '') {
            return;
        }
        aw_dataArray = [];
        let id = Math.floor(Math.random() * (854321165 - 135248951)) + 145263951;
        awJq(this).attr('id', id);
        let uid = '#' + id;
        let component = '<div class="aw_application cs">' +
            '<p>' + aw_unsupportedBrowserError + '</p>' +
            '</div>';
        if (aw_insideLink) {
            awJq(uid).append(component);
        } else {
            awJq(uid).after(component);
        }
    })
}

function startSc() {
    if (aw_insideLink) {
        awJq('a[data-allibo]').on("click", function (event) {
            event.preventDefault();
        });
        awJq('a[data-allibo]').css({ "color": "inherit", "text-decoration": "inherit" });
    }
    awJq('a[data-allibo]').each(function () {
        let href = awJq(this).attr('href');
        let rel = awJq(this).attr('rel');
        let url = awJq(this).attr('data-allibo');
        if (href != 'https://allibo.com' || rel != 'follow' || url == null || url == '') {
            return;
        }
        aw_dataArray = [];
        let id = Math.floor(Math.random() * (854321165 - 135248951)) + 145263951;
        awJq(this).attr('id', id);
        let uid = '#' + id;
        aw_getJSON(url, uid);
    })
}

function aw_getJSON(url1, refElement) {
    awJq.ajax({
        url: url1,
        type: 'GET'
    }).done(function (result) {
        aw_createHTML(result, refElement);
    }).fail(function (request, textStatus, errorThrown) {
        console.log('Error');
        console.log(request.status);
        console.log(request.statusText);
        console.log(request.readyState);
        console.log(textStatus);
        console.log(errorThrown);
    });
}

function aw_createHTML(json, refElement) {
    let id = refElement.substring(1);
    // try {
    returnCode = json.ReturnCode;
    if (returnCode <= 0) {
        behavior = json.Content.WidgetData;
        adsList = json.Content.WidgetData.AdsList;
        aw_dataArray[refElement] = json.Content;
        if (!document.getElementById('link' + id)) {
            let links = document.getElementsByTagName('link');
            let toAdd = true;
            for (let i = 0; i < links.length; i++) {
                if (links[i].href == json.Content.CssUrl) {
                    toAdd = false;
                }
            }
            if (toAdd) {
                let link = document.createElement('link');
                link.id = 'link' + id;
                link.rel = 'stylesheet';
                link.href = json.Content.CssUrl;
                document.head.appendChild(link);
            }
        }
        switch (json.Content.WidgetTypeCode) {
            case 'S':
                aw_generateSpontaneous(behavior, refElement);
                break;
            case 'C':
                aw_generateCarousel(behavior, adsList, refElement);
                break;
            case 'L':
                aw_generateList(behavior, adsList, refElement);
                break;
            case 'E':
                aw_generateSearchEngine(behavior, adsList, refElement);
                break;
            default:
                alert('Tipologia Widget non riconosciuta: ' + json.Content.WidgetTypeCode);
                break;
        }
    } else {
        aw_widgetError(json, refElement);
    }

}
function aw_widgetError(json, refElement) {
    let returnCode = json.ReturnCode;
    let message = json.ReturnMessage;
    let div = '';
    if (returnCode) {
        div = '<div> <p> ';
        if (aw_printReturnCode) {
            div += ' (' + returnCode + ') '
        }
        if (message && message.length > 0) {
            div += ' ' + message + ' <p></div>';
        }
    } else {
        div = ' <div><p>Link non valido</p></div>';
    }
    if (aw_insideLink) {
        awJq(refElement).append(div);
    } else {
        awJq(refElement).after(div);
    }
}

function aw_generateSpontaneous(behavior, refElement) {
    let id = refElement.substring(1);
    let component = ''; // Componente padre
    let spn_section = ''; // Sezione SpontaneousApplication
    let linkToSend = {
        link: behavior.SpontaneousButtonLink
    };
    linkToSend = JSON.stringify(linkToSend);
    if (behavior.Intro) {
        spn_section += '<p class="aw_intro">' + behavior.Intro + '</p>';
    }
    spn_section +=
        "<a class='aw_applyLink' onclick='asw_openDetail("+linkToSend+")'> "+behavior.SpontaneousButtonLabel+" </a>";
    component = '<div class="aw_application cs">' +
        spn_section +
        '</div>';
    if (aw_insideLink) {
        awJq(refElement).append(component);
    } else {
        awJq(refElement).after(component);
    }
}

function aw_getSingleDivAdsHTML(ads, index, refElement, iscarousel) {
    let id = refElement.substring(1);
    let divAdsList = '';
    let className = 'aw_jobPosting';
    let linkToSend = {
        link: ads.DetailLink
    };
    linkToSend = JSON.stringify(linkToSend);
    if (iscarousel) {
        className = 'aw_jobPosting ';
    }
    places = '';
    provinceCode = '';

    awJq.each(ads.ListPlaces, function (index, place) {
        citta = '';
        if (place.PlaceName != null) {
            citta = place.PlaceName;
        } else {
            citta = place.ProvinceName;
        }
        places += citta + ', ' + place.ProvinceCode + ' (' + place.CountryName + ')';
        provinceCode += place.ProvinceCode + ' ';
    });
    // Id singolo annuncio: aw_jobPosting
    divAdsList +=
        // '<div class="' + className + ' ' + ads.StyleClass + ' is-visible" rel="nofollow" data-kyw="' + ads.Title.toUpperCase() + ';' + '" data-ref="' + index + '" ' +
        // 'data-prv="' + provinceCode + '" onclick="window.open(\'' + ads.DetailLink + ',JobAd,width=900,height=600,status=yes,resizable=yes,scrollbars=yes\')">';
        "<div class='" + className + " " + ads.StyleClass + " is-visible' rel='nofollow' data-kyw='" + ads.Title.toUpperCase() + ";' data-ref='" + index + "' " +
        "data-prv='" + provinceCode + "' onclick='asw_openDetail(" + linkToSend + ")'>";
    if (ads.Rush.length > 0) {
        divAdsList += ads.Rush;
    }
    divAdsList +=
        '<h3 class="aw_title">' +
        ads.Title +
        '</h3>' +
        '<p class="aw_location">' +
        ads.JobLocation +
        '</p>' +
        '</div>';
    return divAdsList;
}

function aw_getDivAdsListCarouselHTML(adsList, refElement) {
    let divAdsList = '';
    let iscarousel = true;
    awJq.each(adsList, function (index, ads) {
        divAdsList += aw_getSingleDivAdsHTML(ads, index, refElement, iscarousel);
    });
    return divAdsList;
}

function aw_generateCarouselList(behavior, adsList, refElement) {
    let id = refElement.substring(1);
    let component = ''; // Componente padre
    let adv_section = ''; // Sezione annunci
    let divAdsList = ''; // Sezione annunci
    if (behavior.Intro) {
        adv_section += '<p class="aw_intro" id="aw_intro' + id + '">' + behavior.Intro + '</p>';
    }
    divAdsList = aw_getDivAdsListCarouselHTML(adsList, refElement);
    adv_section +=
        '<div class="aw_vieport aw_vieportcarousel" id="aw_viewport' + id + '">' +
        divAdsList +
        '</div><br />';
    if (adsList.length > 0) {
        component = '<div class="aw_jobSlider cs" id="aw_jobSlider' + id + '">' +
            adv_section +
            '</div>';
    }
    else {
        component = '<div class="aw_jobSlider cs" id="aw_jobSlider' + id + '">' +
            '</div>';
    }
    if (aw_insideLink) {
        awJq(refElement).append(component);
    } else {
        awJq(refElement).after(component);
    }
}

function aw_generateCarousel(behavior, adsList, refElement) {
    let id = refElement.substring(1);
    aw_generateCarouselList(behavior, adsList, refElement);
    aw_initCarousel('#aw_viewport' + id);
    // Se eseguo zoom in o zoom out sulla finestra.
    awJq(window).on('resize', function () {
        let carousels = awJq('div.aw_jobSlider');
        awJq.each(carousels, function (index, carousel) {
            let id = carousel.id.split('r');
            awJq('#' + carousel.id).remove();
            let carouselData = aw_dataArray['#' + id[1]];
            let behavior = carouselData.WidgetData;
            let adsList = carouselData.WidgetData.AdsList;
            aw_generateCarouselList(behavior, adsList, '#' + id[1]);
            aw_initCarousel('#aw_viewport' + id[1]);
        });
    });
}

function aw_getDivAdsListHTML(behavior, adsList, refElement) {
    let id = refElement.substring(1);
    let iscarousel = false;
    let divAdsList = '';
    let listLength = behavior.AdsPageLength.toString();
    // Se lungezza = -1 genero senza paginazione
    if (listLength === '-1') {
        awJq.each(adsList, function (index, ads) {
            divAdsList += aw_getSingleDivAdsHTML(ads, index, refElement, iscarousel);
        });
    }
    else {
        listLength = parseInt(listLength);
        let index = 0;
        let pages = '';
        // Ottengo il numero di pagine che devono essere generate
        let pagesNumber = Math.ceil(adsList.length / listLength);
        let list = '';
        let nav = '';
        // Div principale
        pages += '<div class="aw_pages aw_pages' + id + '">';
        for (let i = 0; i < pagesNumber; i++) {
            // if (i + 1 === pagesNumber) {

            // }
            // Div della pagina
            list += '<div class="aw_page aw_page' + id + '" id="page' + (i + 1) + '' + id + '" data-pgnumber="' + (i + 1) + '">'

            for (let j = 0; j < listLength; j++) {
                if (j + (i * listLength) < adsList.length) {
                    list += aw_getSingleDivAdsHTML(adsList[j + (i * listLength)], index, refElement, iscarousel);
                    index++;
                }
            }
            list += '</div>'
        }
        pages += list + '</div>';
        nav += '<div class="aw_pager">';
        nav += '<a class="aw_pagerLink" href="#" id="pageNavBack' + id + '">&#10094;</a>';
        for (let i = 1; i <= pagesNumber; i++) {
            nav += '<a class="aw_pagerLink" href="#" data-pageid="page' + (i) + '' + id + '" id="pageNav' + i + id + '">' + i + '</a>';
        }
        nav += '<a class="aw_pagerLink" href="#" id="pageNavNext' + id + '">&#10095;</a>';
        nav += "</div>";

        divAdsList += pages + nav;
    }
    return divAdsList;
}

function aw_renderListNavigation(refElement) {
    let id = refElement.substring(1);
    // Recupero le pagine del div
    let pages = awJq('#aw_viewport' + id).find('.aw_page' + id);
    // pages = awJq('#aw_viewport' + id).find('.aw_page' + id);
    if (pages.length > 1) {
        // Ciclo le pagine
        for (let i = 0; i < pages.length; i++) {
            // Nascondo tutte le pagine al di fuori della prima
            if (i != 0) {
                awJq('#page' + (i + 1) + '' + id).hide();
            }
            else {
                awJq('#page' + (i + 1) + '' + id).addClass('is-visible');
            }
            // Funzione per i numeri di pagina
            awJq('#aw_viewport' + id).on('click', '#pageNav' + (i + 1) + '' + id, function (event) {
                event.preventDefault();
                // Prendo il page id
                let pageId = '#' + awJq(event.handleObj.selector).data("pageid");
                // Prendo le pagine
                let pages = awJq('#aw_viewport' + id).find('.aw_page' + id);
                awJq.each(pages, function (index, page) {
                    awJq('#' + page.id).hide();
                    awJq('#' + page.id).removeClass('is-visible');
                });
                awJq(pageId).show();
                awJq(pageId).addClass('is-visible');
            });
        }
        // Funzione pagina precedente
        awJq('#aw_viewport' + id).on('click', '#pageNavBack' + id, function (event) {
            event.preventDefault();
            let selectedPage = awJq('#aw_viewport' + id).find('.aw_page' + id + '.is-visible');
            let pages = awJq('#aw_viewport' + id).find('.aw_page' + id);
            let pagesArray = [];
            awJq.each(pages, function (index, pg) {
                pagesArray.push(pg);
            });
            let selectedPagePosition = pagesArray.indexOf(selectedPage[0]);
            let pagesNumber = pages.length;
            if (selectedPagePosition > 0 && selectedPagePosition < pagesNumber) {
                awJq.each(pages, function (index, page) {
                    awJq('#' + page.id).hide();
                    awJq('#' + page.id).removeClass('is-visible');
                });
                awJq('#' + pagesArray[selectedPagePosition - 1].id).show();
                awJq('#' + pagesArray[selectedPagePosition - 1].id).addClass('is-visible');
            }
        });
        // Funzione pagina successiva
        awJq('#aw_viewport' + id).on('click', '#pageNavNext' + id, function (event) {
            event.preventDefault();
            let selectedPage = awJq('#aw_viewport' + id).find('.aw_page' + id + '.is-visible');
            let pages = awJq('#aw_viewport' + id).find('.aw_page' + id);
            let pagesArray = [];
            awJq.each(pages, function (index, pg) {
                pagesArray.push(pg);
            });
            let selectedPagePosition = pagesArray.indexOf(selectedPage[0]);
            let pagesNumber = pages.length;
            if (selectedPagePosition >= 0 && selectedPagePosition < pagesNumber - 1) {
                awJq.each(pages, function (index, page) {
                    awJq('#' + page.id).hide();
                    awJq('#' + page.id).removeClass('is-visible');
                });
                awJq('#' + pagesArray[selectedPagePosition + 1].id).show();
                awJq('#' + pagesArray[selectedPagePosition + 1].id).addClass('is-visible');
            }
        });
    }
}

function aw_generateList(behavior, adsList, refElement) {
    let id = refElement.substring(1);
    let component = ''; // Componente padre
    let adv_section = ''; // Sezione annunci
    let divAdsList = ''; // Sezione annunci
    if (behavior.Intro) {
        adv_section += '<p class="aw_intro" id="aw_intro' + id + '">' + behavior.Intro + '</p>';
    }
    divAdsList = aw_getDivAdsListHTML(behavior, adsList, refElement);
    adv_section +=
        '<div class="aw_viewport" id="aw_viewport' + id + '">' +
        divAdsList +
        '</div><br />';
    // Controllo se ci sono annunci
    if (adsList.length > 0) {
        // Se ci sono annunci
        component +=
            '<div class="aw_jobList cs" id="aw_jobList cs' + id + '">' +
            adv_section +
            '</div>';
    }
    else {
        // Se non ci sono annunci
        component = '<div class="aw_jobList cs" id="aw_jobList cs' + id + '">' +
            '</div>';
    }

    if (aw_insideLink) {
        awJq(refElement).append(component);
    } else {
        awJq(refElement).after(component);
    }

    aw_renderListNavigation(refElement);
}

function aw_generateSearchEngine(behavior, adsList, refElement) {
    let id = refElement.substring(1);
    let component = '';
    let src_section = '';
    let divAdsList = '';
    let adv_section = '';
    let intro = '';
    let filterJobs = '';
    let jobTitles = '';
    let buttonId = 'AdsFilterSearch' + id;
    let filterJobId = 'FlgAdsFilterJobs' + id;
    let filterPlaceId = 'FlgAdsFilterPlace' + id;

    if (behavior.Intro) {
        intro += '<p class="aw_intro" id="aw_intro' + id + '">' + behavior.Intro + '</p>';
    }
    src_section += '<div class="aw_searchBox">';
    let searchButton = '';
    if (behavior.FlgAdsFilterJobs || behavior.FlgAdsFilterPlace) {
        searchButton += '<div class="aw_searchButton">' +
            '<i class="far fa-search"></i>'
        searchButton += '<button id="' + buttonId + '" aria-label="Cerca"></button>';
        searchButton += '</div>';
        src_section += searchButton;
    }

    if (behavior.FlgAdsFilterJob) {
        filterJobs +=
            '<select class="aw_select" id="' + filterJobId + '" name="FlgAdsFilterJob" >' +
            '<option value="-1">' +
            behavior.AdsFilterJobLabel
        '</option>';
        awJq.each(adsList, function (index, ads) {
            if (jobTitles.indexOf(ads.Job) >= 0) {
                return;
            }
            jobTitles += ads.Job + '#';
            filterJobs += '<option value="' + ads.Job + '">' + ads.Job + '</option>';
        });
        filterJobs += '</select>';

        src_section += filterJobs;
    }

    let filterPlace = '';
    let codeList = '';
    if (behavior.FlgAdsFilterPlace) {
        filterPlace +=
            '<select class="aw_select" id="' + filterPlaceId + '" name="FlgAdsFilterPlace" >' +
            '<option value="-1">' +
            behavior.AdsFilterPlaceLabel +
            '</option>';
        // Per ogni annuncio
        awJq.each(adsList, function (index, ads) {
            // Per ogni posto
            awJq.each(ads.ListPlaces, function (index, place) {
                // Creo il valore country:proince
                let country = place.CountryCode ? place.CountryCode : '';
                let province = place.ProvinceCode ? place.ProvinceCode : '';
                let codeVal = country + ":" + province;
                let codeValTemp = "/"+codeVal+"\\";
                if (codeList.indexOf(codeValTemp) >= 0) {
                    return;
                }
                let displayPlace = '';
                codeList += codeValTemp;
                if (place.CountryName && place.ProvinceName) {
                    displayPlace = place.CountryName + ' / ' + place.ProvinceName;
                } else {
                    displayPlace = place.CountryName ? place.CountryName : place.ProvinceName;
                }
                filterPlace += '<option value=' + codeVal + '>' + displayPlace + '</option>';
            });
        });
        filterPlace += '</select>';
        src_section += filterPlace;
    }
    src_section += '</div>';

    if (adsList.length > 0) {
        divAdsList = aw_getDivAdsListHTML(behavior, adsList, refElement);
    } else {
        let noResults = behavior.AdsNoResults ? behavior.AdsNoResults : '';
        divAdsList = '<p>' + noResults + '</p>'
    }
    adv_section +=
        '<div class="aw_viewport aw_viewport' + id + '" id="aw_viewport' + id + '">' +
        divAdsList +
        '</div><br />';

    component = '<div class="aw_jobList cs">' +
        src_section +
        intro +
        adv_section
    '</div>';
    if (aw_insideLink) {
        awJq(refElement).append(component);
    } else {
        awJq(refElement).after(component);
    }
    aw_renderListNavigation(refElement);
    if (behavior.FlgFirstSearchEmpty) {
        awJq('.aw_viewport' + id).hide();
    }
    awJq('#' + buttonId).on('click', function () {
        let filterJob = awJq('#' + filterJobId).val();
        let filterPlace = awJq('#' + filterPlaceId).val();
        aw_search(refElement, filterJob, filterPlace);
    });
}

function aw_search(uid, job, place) {
    let adv_section = '';
    let id = uid.substring(1);
    // Rendo il contenitore visibile
    awJq('.aw_viewport' + id).show();
    // Ottengo gli annunci dal div content.
    const tempArray = aw_dataArray[uid].WidgetData.AdsList;
    let listData = Array.from(tempArray);
    let firstFilter = [];
    let secondFilter = [];
    if (job && job != '-1') {
        for (let i = 0; i < listData.length; i++) {
            if (listData[i].Job === job) {
                firstFilter.push(listData[i]);
            }
        }
    }
    else {
        firstFilter = Array.from(listData);
    }
    if (place && place != '-1') {
        for (let i = 0; i < firstFilter.length; i++) {
            if (firstFilter[i].ListPlaces) {
                let toAdd = true;
                for (let j = 0; j < firstFilter[i].ListPlaces.length; j++) {
                    // let codeVal = `${firstFilter[i].ListPlaces[j].CountryCode}:${firstFilter[i].ListPlaces[j].ProvinceCode}`;
                    let codeVal = firstFilter[i].ListPlaces[j].CountryCode+":"+firstFilter[i].ListPlaces[j].ProvinceCode;
                    if (codeVal.indexOf(place) >= 0) {
                        if (toAdd) {
                            secondFilter.push(firstFilter[i]);
                            toAdd = false;
                        }
                    }
                }
            }
        }
    }
    else {
        secondFilter = firstFilter;
    }
    if (secondFilter.length > 0) {
        divAdsList = aw_getDivAdsListHTML(aw_dataArray[uid].WidgetData, secondFilter, uid);
    } else {
        let noResults = behavior.AdsNoResults ? behavior.AdsNoResults : '';
        divAdsList = '<p>' + noResults + '</p>'
    }
    adv_section +=
        '<div class="aw_viewport aw_viewport' + id + '" id="aw_viewport' + id + '">' +
        divAdsList +
        '</div>';
    awJq('.aw_viewport' + id).replaceWith(adv_section);

    aw_renderListNavigation(uid);

    return false;
}

function aw_initCarousel(container) {
    awJq(container).tzs_show({
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        cellAlign: 'left',
        autoPlay: true,
        adaptiveHeight: false,
        percentPosition: false,
        cellSelector: '.aw_jobPosting.is-visible'
    });
}

function asw_openDetail(link) {
    // console.log('Click!');
    // Calcolo dimensioni delle finestre
    let v_height = Math.min(Math.round(screen.height * 0.84), 900);
    let v_width = 720;
    if (screen.width >= 1391) { v_width = 1152; }
    else if (screen.width >= 1152) { v_width = 1027; }
    else if (screen.width >= 1024) { v_width = 980; }
    let wHandle = window.open(link.link, 'aw_window', 'width=' + v_width + ',height=' + v_height + ',scrollbars=yes,location=no,toolbar=no,menubar=no,status=no,resizable=yes');
    wHandle.focus();
}
// --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------


/*!
 * flickity PACKAGED v2.2.1
 * Touch, responsive, flickable carousels
 */

(function (window, factory) {
    // universal module definition
    /*jshint strict: false */ /* globals define, module, require */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('jquery-bridget/jquery-bridget', ['jquery'], function (awJq) {
            return factory(window, awJq);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('jquery')
        );
    } else {
        // browser global
        window.jQueryBridget = factory(
            window,
            awJq
        );
    }

}(window, function factory(window, awJq) {
    'use strict';

    // ----- utils ----- //

    let arraySlice = Array.prototype.slice;

    // helper function for logging errors
    // $.error breaks jQuery chaining
    let console = window.console;
    let logError = typeof console == 'undefined' ? function () { } :
        function (message) {
            console.error(message);
        };

    // ----- jQueryBridget ----- //
    function jQueryBridget(namespace, PluginClass) {
        // $ = $ || jQuery || window.jQuery;
        if (!awJq) {
            console.error('aw_error jQueryBridget fail');
            return;
        }
        // add option method -> $().plugin('option', {...})
        if (!PluginClass.prototype.option) {
            // option setter
            PluginClass.prototype.option = function (opts) {
                // bail out if not an object
                if (!awJq.isPlainObject(opts)) {
                    return;
                }
                this.options = awJq.extend(true, this.options, opts);
            };
        }
        // make jQuery plugin
        awJq.fn[namespace] = function (arg0 /*, arg1 */) {
            if (typeof arg0 == 'string') {
                // method call $().plugin( 'methodName', { options } )
                // shift arguments by 1
                let args = arraySlice.call(arguments, 1);
                return methodCall(this, arg0, args);
            }
            // just $().plugin({ options })
            plainCall(this, arg0);
            return this;
        };

        // $().plugin('methodName')
        function methodCall($elems, methodName, args) {
            let returnValue;
            let pluginMethodStr = 'awJq().' + namespace + '("' + methodName + '")';

            $elems.each(function (i, elem) {
                // get instance
                let instance = awJq.data(elem, namespace);
                if (!instance) {
                    logError(namespace + ' not initialized. Cannot call methods, i.e. ' +
                        pluginMethodStr);
                    return;
                }

                let method = instance[methodName];
                if (!method || methodName.charAt(0) == '_') {
                    logError(pluginMethodStr + ' is not a valid method');
                    return;
                }

                // apply method, get return value
                let value = method.apply(instance, args);
                // set return value if value is returned, use only first value
                returnValue = returnValue === undefined ? value : returnValue;
            });

            return returnValue !== undefined ? returnValue : $elems;
        }

        function plainCall($elems, options) {
            $elems.each(function (i, elem) {
                let instance = awJq.data(elem, namespace);
                if (instance) {
                    // set options & init
                    instance.option(options);
                    instance._init();
                } else {
                    // initialize new instance
                    instance = new PluginClass(elem, options);
                    awJq.data(elem, namespace, instance);
                }
            });
        }

        updateJQuery(awJq);

    }

    // ----- updateJQuery ----- //

    // set $.bridget for v1 backwards compatibility
    function updateJQuery(awJq) {
        if (!awJq || (awJq && awJq.bridget)) {
            return;
        }
        awJq.bridget = jQueryBridget;
    }

    updateJQuery(awJq);

    // -----  ----- //

    return jQueryBridget;

}));

/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

(function (global, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, window */
    if (typeof define == 'function' && define.amd) {
        // AMD - RequireJS
        define('ev-emitter/ev-emitter', factory);
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS - Browserify, Webpack
        module.exports = factory();
    } else {
        // Browser globals
        global.EvEmitter = factory();
    }

}(typeof window != 'undefined' ? window : this, function () {



    function EvEmitter() { }

    let proto = EvEmitter.prototype;

    proto.on = function (eventName, listener) {
        if (!eventName || !listener) {
            return;
        }
        // set events hash
        let events = this._events = this._events || {};
        // set listeners array
        let listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (listeners.indexOf(listener) == -1) {
            listeners.push(listener);
        }

        return this;
    };

    proto.once = function (eventName, listener) {
        if (!eventName || !listener) {
            return;
        }
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        let onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;

        return this;
    };

    proto.off = function (eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) {
            return;
        }
        let index = listeners.indexOf(listener);
        if (index != -1) {
            listeners.splice(index, 1);
        }

        return this;
    };

    proto.emitEvent = function (eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) {
            return;
        }
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        let onceListeners = this._onceEvents && this._onceEvents[eventName];

        for (let i = 0; i < listeners.length; i++) {
            let listener = listeners[i]
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }

        return this;
    };

    proto.allOff = function () {
        delete this._events;
        delete this._onceEvents;
    };

    return EvEmitter;

}));

/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

(function (window, factory) {
    /* jshint strict: false */ /* globals define, module */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('get-size/get-size', factory);
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    } else {
        // browser global
        window.getSize = factory();
    }

})(window, function factory() {
    'use strict';

    // -------------------------- helpers -------------------------- //

    // get a number from a string, not a percentage
    function getStyleSize(value) {
        let num = parseFloat(value);
        // not a percent like '100%', and a number
        let isValid = value.indexOf('%') == -1 && !isNaN(num);
        return isValid && num;
    }

    function noop() { }

    let logError = typeof console == 'undefined' ? noop :
        function (message) {
            console.error(message);
        };

    // -------------------------- measurements -------------------------- //

    let measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth'
    ];

    let measurementsLength = measurements.length;

    function getZeroSize() {
        let size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        for (let i = 0; i < measurementsLength; i++) {
            let measurement = measurements[i];
            size[measurement] = 0;
        }
        return size;
    }

    // -------------------------- getStyle -------------------------- //

    /**
     * getStyle, get style of element, check for Firefox bug
     * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
     */
    function getStyle(elem) {
        let style = getComputedStyle(elem);
        if (!style) {
            logError('Style returned ' + style +
                '. Are you running this code in a hidden iframe on Firefox? ' +
                'See https://bit.ly/getsizebug1');
        }
        return style;
    }

    // -------------------------- setup -------------------------- //

    let isSetup = false;

    let isBoxSizeOuter;

    /**
     * setup
     * check isBoxSizerOuter
     * do on first getSize() rather than on page load for Firefox bug
     */
    function setup() {
        // setup once
        if (isSetup) {
            return;
        }
        isSetup = true;

        // -------------------------- box sizing -------------------------- //

        /**
         * Chrome & Safari measure the outer-width on style.width on border-box elems
         * IE11 & Firefox<29 measures the inner-width
         */
        let div = document.createElement('div');
        div.style.width = '200px';
        div.style.padding = '1px 2px 3px 4px';
        div.style.borderStyle = 'solid';
        div.style.borderWidth = '1px 2px 3px 4px';
        div.style.boxSizing = 'border-box';

        let body = document.body || document.documentElement;
        body.appendChild(div);
        let style = getStyle(div);
        // round value for browser zoom. desandro/masonry#928
        isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
        getSize.isBoxSizeOuter = isBoxSizeOuter;

        body.removeChild(div);
    }

    // -------------------------- getSize -------------------------- //

    function getSize(elem) {
        setup();

        // use querySeletor if elem is string
        if (typeof elem == 'string') {
            elem = document.querySelector(elem);
        }

        // do not proceed on non-objects
        if (!elem || typeof elem != 'object' || !elem.nodeType) {
            return;
        }

        let style = getStyle(elem);

        // if hidden, everything is 0
        if (style.display == 'none') {
            return getZeroSize();
        }

        let size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;

        let isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

        // get all measurements
        for (let i = 0; i < measurementsLength; i++) {
            let measurement = measurements[i];
            let value = style[measurement];
            let num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        }

        let paddingWidth = size.paddingLeft + size.paddingRight;
        let paddingHeight = size.paddingTop + size.paddingBottom;
        let marginWidth = size.marginLeft + size.marginRight;
        let marginHeight = size.marginTop + size.marginBottom;
        let borderWidth = size.borderLeftWidth + size.borderRightWidth;
        let borderHeight = size.borderTopWidth + size.borderBottomWidth;

        let isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

        // overwrite width and height if we can get it from style
        let styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) {
            size.width = styleWidth +
                // add padding and border unless it's already including it
                (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
        }

        let styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) {
            size.height = styleHeight +
                // add padding and border unless it's already including it
                (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
        }

        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);

        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;

        return size;
    }

    return getSize;

});

/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

(function (window, factory) {
    /*global define: false, module: false */
    'use strict';
    // universal module definition
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('desandro-matches-selector/matches-selector', factory);
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    } else {
        // browser global
        window.matchesSelector = factory();
    }

}(window, function factory() {
    'use strict';

    let matchesMethod = (function () {
        let ElemProto = window.Element.prototype;
        // check for the standard method name first
        if (ElemProto.matches) {
            return 'matches';
        }
        // check un-prefixed
        if (ElemProto.matchesSelector) {
            return 'matchesSelector';
        }
        // check vendor prefixes
        let prefixes = ['webkit', 'moz', 'ms', 'o'];

        for (let i = 0; i < prefixes.length; i++) {
            let prefix = prefixes[i];
            let method = prefix + 'MatchesSelector';
            if (ElemProto[method]) {
                return method;
            }
        }
    })();

    return function matchesSelector(elem, selector) {
        return elem[matchesMethod](selector);
    };

}));

/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

(function (window, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */

    if (typeof define == 'function' && define.amd) {
        // AMD
        define('fizzy-ui-utils/utils', [
            'desandro-matches-selector/matches-selector'
        ], function (matchesSelector) {
            return factory(window, matchesSelector);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('desandro-matches-selector')
        );
    } else {
        // browser global
        window.fizzyUIUtils = factory(
            window,
            window.matchesSelector
        );
    }

}(window, function factory(window, matchesSelector) {

    let utils = {};

    // ----- extend ----- //

    // extends objects
    utils.extend = function (a, b) {
        for (let prop in b) {
            a[prop] = b[prop];
        }
        return a;
    };

    // ----- modulo ----- //

    utils.modulo = function (num, div) {
        return ((num % div) + div) % div;
    };

    // ----- makeArray ----- //

    let arraySlice = Array.prototype.slice;

    // turn element or nodeList into an array
    utils.makeArray = function (obj) {
        if (Array.isArray(obj)) {
            // use object if already an array
            return obj;
        }
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) {
            return [];
        }

        let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        if (isArrayLike) {
            // convert nodeList to array
            return arraySlice.call(obj);
        }

        // array of single index
        return [obj];
    };

    // ----- removeFrom ----- //

    utils.removeFrom = function (ary, obj) {
        let index = ary.indexOf(obj);
        if (index != -1) {
            ary.splice(index, 1);
        }
    };

    // ----- getParent ----- //

    utils.getParent = function (elem, selector) {
        while (elem.parentNode && elem != document.body) {
            elem = elem.parentNode;
            if (matchesSelector(elem, selector)) {
                return elem;
            }
        }
    };

    // ----- getQueryElement ----- //

    // use element as selector string
    utils.getQueryElement = function (elem) {
        if (typeof elem == 'string') {
            return document.querySelector(elem);
        }
        return elem;
    };

    // ----- handleEvent ----- //

    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function (event) {
        let method = 'on' + event.type;
        if (this[method]) {
            this[method](event);
        }
    };

    // ----- filterFindElements ----- //

    utils.filterFindElements = function (elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        let ffElems = [];

        elems.forEach(function (elem) {
            // check that elem is an actual element
            if (!(elem instanceof HTMLElement)) {
                return;
            }
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return;
            }
            // filter & find items if we have a selector
            // filter
            if (matchesSelector(elem, selector)) {
                ffElems.push(elem);
            }
            // find children
            let childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            for (let i = 0; i < childElems.length; i++) {
                ffElems.push(childElems[i]);
            }
        });

        return ffElems;
    };

    // ----- debounceMethod ----- //

    utils.debounceMethod = function (_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        let method = _class.prototype[methodName];
        let timeoutName = methodName + 'Timeout';

        _class.prototype[methodName] = function () {
            let timeout = this[timeoutName];
            clearTimeout(timeout);

            let args = arguments;
            let _this = this;
            this[timeoutName] = setTimeout(function () {
                method.apply(_this, args);
                delete _this[timeoutName];
            }, threshold);
        };
    };

    // ----- docReady ----- //

    utils.docReady = function (callback) {
        let readyState = document.readyState;
        if (readyState == 'complete' || readyState == 'interactive') {
            // do async to allow for other scripts to run. metafizzy/tzs_show#441
            setTimeout(callback);
        } else {
            document.addEventListener('DOMContentLoaded', callback);
        }
    };

    // ----- htmlInit ----- //

    // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
    utils.toDashed = function (str) {
        return str.replace(/(.)([A-Z])/g, function (match, $1, $2) {
            return $1 + '-' + $2;
        }).toLowerCase();
    };

    let console = window.console;
    /**
     * allow user to initialize classes via [data-namespace] or .js-namespace class
     * htmlInit( Widget, 'widgetName' )
     * options are parsed from data-namespace-options
     */
    utils.htmlInit = function (WidgetClass, namespace) {
        utils.docReady(function () {
            let dashedNamespace = utils.toDashed(namespace);
            let dataAttr = 'data-' + dashedNamespace;
            let dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
            let jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
            let elems = utils.makeArray(dataAttrElems)
                .concat(utils.makeArray(jsDashElems));
            let dataOptionsAttr = dataAttr + '-options';
            let jQuery = awJq;

            elems.forEach(function (elem) {
                let attr = elem.getAttribute(dataAttr) ||
                    elem.getAttribute(dataOptionsAttr);
                let options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) {
                        console.error('Error parsing ' + dataAttr + ' on ' + elem.className +
                            ': ' + error);
                    }
                    return;
                }
                // initialize
                let instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) {
                    jQuery.data(elem, namespace, instance);
                }
            });

        });
    };

    // -----  ----- //

    return utils;

}));

// tzs_show.Cell
(function (window, factory) {
    // universal module definition
    /* jshint strict: false */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('tzs_show/js/cell', [
            'get-size/get-size'
        ], function (getSize) {
            return factory(window, getSize);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('get-size')
        );
    } else {
        // browser global
        window.tzs_show = window.tzs_show || {};
        window.tzs_show.Cell = factory(
            window,
            window.getSize
        );
    }

}(window, function factory(window, getSize) {



    function Cell(elem, parent) {
        this.element = elem;
        this.parent = parent;

        this.create();
    }

    let proto = Cell.prototype;

    proto.create = function () {
        this.element.style.position = 'absolute';
        this.element.setAttribute('aria-hidden', 'true');
        this.x = 0;
        this.shift = 0;
    };

    proto.destroy = function () {
        // reset style
        this.unselect();
        this.element.style.position = '';
        let side = this.parent.originSide;
        this.element.style[side] = '';
    };

    proto.getSize = function () {
        this.size = getSize(this.element);
    };

    proto.setPosition = function (x) {
        this.x = x;
        this.updateTarget();
        this.renderPosition(x);
    };

    // setDefaultTarget v1 method, backwards compatibility, remove in v3
    proto.updateTarget = proto.setDefaultTarget = function () {
        let marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
        this.target = this.x + this.size[marginProperty] +
            this.size.width * this.parent.cellAlign;
    };

    proto.renderPosition = function (x) {
        // render position of cell with in slider
        let side = this.parent.originSide;
        this.element.style[side] = this.parent.getPositionValue(x);
    };

    proto.select = function () {
        this.element.classList.add('is-selected');
        this.element.removeAttribute('aria-hidden');
    };

    proto.unselect = function () {
        this.element.classList.remove('is-selected');
        this.element.setAttribute('aria-hidden', 'true');
    };

    /**
     * @param {Integer} factor - 0, 1, or -1
     **/
    proto.wrapShift = function (shift) {
        this.shift = shift;
        this.renderPosition(this.x + this.parent.slideableWidth * shift);
    };

    proto.remove = function () {
        this.element.parentNode.removeChild(this.element);
    };

    return Cell;

}));

// slide
(function (window, factory) {
    // universal module definition
    /* jshint strict: false */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('tzs_show/js/slide', factory);
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    } else {
        // browser global
        window.tzs_show = window.tzs_show || {};
        window.tzs_show.Slide = factory();
    }

}(window, function factory() {
    'use strict';

    function Slide(parent) {
        this.parent = parent;
        this.isOriginLeft = parent.originSide == 'left';
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
    }

    let proto = Slide.prototype;

    proto.addCell = function (cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        // first cell stuff
        if (this.cells.length == 1) {
            this.x = cell.x; // x comes from first cell
            let beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
            this.firstMargin = cell.size[beginMargin];
        }
    };

    proto.updateTarget = function () {
        let endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
        let lastCell = this.getLastCell();
        let lastMargin = lastCell ? lastCell.size[endMargin] : 0;
        let slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
    };

    proto.getLastCell = function () {
        return this.cells[this.cells.length - 1];
    };

    proto.select = function () {
        this.cells.forEach(function (cell) {
            cell.select();
        });
    };

    proto.unselect = function () {
        this.cells.forEach(function (cell) {
            cell.unselect();
        });
    };

    proto.getCellElements = function () {
        return this.cells.map(function (cell) {
            return cell.element;
        });
    };

    return Slide;

}));

// animate
(function (window, factory) {
    // universal module definition
    /* jshint strict: false */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('tzs_show/js/animate', [
            'fizzy-ui-utils/utils'
        ], function (utils) {
            return factory(window, utils);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('fizzy-ui-utils')
        );
    } else {
        // browser global
        window.tzs_show = window.tzs_show || {};
        window.tzs_show.animatePrototype = factory(
            window,
            window.fizzyUIUtils
        );
    }

}(window, function factory(window, utils) {



    // -------------------------- animate -------------------------- //

    let proto = {};

    proto.startAnimation = function () {
        if (this.isAnimating) {
            return;
        }

        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
    };

    proto.animate = function () {
        this.applyDragForce();
        this.applySelectedAttraction();

        let previousX = this.x;

        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        // animate next frame
        if (this.isAnimating) {
            let _this = this;
            requestAnimationFrame(function animateFrame() {
                _this.animate();
            });
        }
    };

    proto.positionSlider = function () {
        let x = this.x;
        // wrap position around
        if (this.options.wrapAround && this.cells.length > 1) {
            x = utils.modulo(x, this.slideableWidth);
            x = x - this.slideableWidth;
            this.shiftWrapCells(x);
        }

        this.setTranslateX(x, this.isAnimating);
        this.dispatchScrollEvent();
    };

    proto.setTranslateX = function (x, is3d) {
        x += this.cursorPosition;
        // reverse if right-to-left and using transform
        x = this.options.rightToLeft ? -x : x;
        let translateX = this.getPositionValue(x);
        // use 3D tranforms for hardware acceleration on iOS
        // but use 2D when settled, for better font-rendering
        this.slider.style.transform = is3d ?
            'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
    };

    proto.dispatchScrollEvent = function () {
        let firstSlide = this.slides[0];
        if (!firstSlide) {
            return;
        }
        let positionX = -this.x - firstSlide.target;
        let progress = positionX / this.slidesWidth;
        this.dispatchEvent('scroll', null, [progress, positionX]);
    };

    proto.positionSliderAtSelected = function () {
        if (!this.cells.length) {
            return;
        }
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
    };

    proto.getPositionValue = function (position) {
        if (this.options.percentPosition) {
            // percent position, round to 2 digits, like 12.34%
            return (Math.round((position / this.size.innerWidth) * 10000) * 0.01) + '%';
        } else {
            // pixel positioning
            return Math.round(position) + 'px';
        }
    };

    proto.settle = function (previousX) {
        // keep track of frames where x hasn't moved
        if (!this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100)) {
            this.restingFrames++;
        }
        // stop animating if resting for 3 or more frames
        if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent('settle', null, [this.selectedIndex]);
        }
    };

    proto.shiftWrapCells = function (x) {
        // shift before cells
        let beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        // shift after cells
        let afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
    };

    proto._shiftCells = function (cells, gap, shift) {
        for (let i = 0; i < cells.length; i++) {
            let cell = cells[i];
            let cellShift = gap > 0 ? shift : 0;
            cell.wrapShift(cellShift);
            gap -= cell.size.outerWidth;
        }
    };

    proto._unshiftCells = function (cells) {
        if (!cells || !cells.length) {
            return;
        }
        for (let i = 0; i < cells.length; i++) {
            cells[i].wrapShift(0);
        }
    };

    // -------------------------- physics -------------------------- //

    proto.integratePhysics = function () {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
    };

    proto.applyForce = function (force) {
        this.velocity += force;
    };

    proto.getFrictionFactor = function () {
        return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
    };

    proto.getRestingPosition = function () {
        // my thanks to Steven Wittens, who simplified this math greatly
        return this.x + this.velocity / (1 - this.getFrictionFactor());
    };

    proto.applyDragForce = function () {
        if (!this.isDraggable || !this.isPointerDown) {
            return;
        }
        // change the position to drag position by applying force
        let dragVelocity = this.dragX - this.x;
        let dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
    };

    proto.applySelectedAttraction = function () {
        // do not attract if pointer down or no slides
        let dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) {
            return;
        }
        let distance = this.selectedSlide.target * -1 - this.x;
        let force = distance * this.options.selectedAttraction;
        this.applyForce(force);
    };

    return proto;

}));

// tzs_show main
(function (window, factory) {
    // universal module definition
    /* jshint strict: false */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('tzs_show/js/tzs_show', [
            'ev-emitter/ev-emitter',
            'get-size/get-size',
            'fizzy-ui-utils/utils',
            './cell',
            './slide',
            './animate'
        ], function (EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
            return factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('ev-emitter'),
            require('get-size'),
            require('fizzy-ui-utils'),
            require('./cell'),
            require('./slide'),
            require('./animate')
        );
    } else {
        // browser global
        let _tzs_show = window.tzs_show;

        window.tzs_show = factory(
            window,
            window.EvEmitter,
            window.getSize,
            window.fizzyUIUtils,
            _tzs_show.Cell,
            _tzs_show.Slide,
            _tzs_show.animatePrototype
        );
    }

}(window, function factory(window, EvEmitter, getSize,
                           utils, Cell, Slide, animatePrototype) {



    // lets
    let jQuery = window.jQuery;
    let getComputedStyle = window.getComputedStyle;
    let console = window.console;

    function moveElements(elems, toElem) {
        elems = utils.makeArray(elems);
        while (elems.length) {
            toElem.appendChild(elems.shift());
        }
    }

    // -------------------------- tzs_show -------------------------- //

    // globally unique identifiers
    let GUID = 0;
    // internal store of all tzs_show intances
    let instances = {};

    function tzs_show(element, options) {
        let queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) {
                console.error('Bad element for tzs_show: ' + (queryElement || element));
            }
            return;
        }
        this.element = queryElement;
        // do not initialize twice on same element
        if (this.element.tzs_showGUID) {
            let instance = instances[this.element.tzs_showGUID];
            instance.option(options);
            return instance;
        }

        // add jQuery
        if (awJq) {
            this.$element = awJq(this.element);
        }
        // options
        this.options = utils.extend({}, this.constructor.defaults);
        this.option(options);

        // kick things off
        this._create();
    }

    tzs_show.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: 'center',
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075, // friction when free-scrolling
        friction: 0.28, // friction when selecting
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true
        // watchCSS: false,
        // wrapAround: false
    };

    // hash of methods triggered on _create()
    tzs_show.createMethods = [];

    let proto = tzs_show.prototype;
    // inherit EventEmitter
    utils.extend(proto, EvEmitter.prototype);

    proto._create = function () {
        // add id for tzs_show.data
        let id = this.guid = ++GUID;
        this.element.tzs_showGUID = id; // expando
        instances[id] = this; // associate via id
        // initial properties
        this.selectedIndex = 0;
        // how many frames slider has been in same position
        this.restingFrames = 0;
        // initial physics properties
        this.x = 0;
        this.velocity = 0;
        this.originSide = this.options.rightToLeft ? 'right' : 'left';
        // create viewport & slider
        this.viewport = document.createElement('div');
        this.viewport.className = 'tsz_show-vieport';
        this._createSlider();

        if (this.options.resize || this.options.watchCSS) {
            window.addEventListener('resize', this);
        }

        // add listeners from on option
        for (let eventName in this.options.on) {
            let listener = this.options.on[eventName];
            this.on(eventName, listener);
        }

        tzs_show.createMethods.forEach(function (method) {
            this[method]();
        }, this);

        if (this.options.watchCSS) {
            this.watchCSS();
        } else {
            this.activate();
        }

    };

    /**
     * set options
     * @param {Object} opts
     */
    proto.option = function (opts) {
        utils.extend(this.options, opts);
    };

    proto.activate = function () {
        if (this.isActive) {
            return;
        }
        this.isActive = true;
        this.element.classList.add('tzs_show-enabled');
        if (this.options.rightToLeft) {
            this.element.classList.add('tzs_show-rtl');
        }

        this.getSize();
        // move initial cell elements so they can be loaded as cells
        let cellElems = this._filterFindCellElements(this.element.children);
        moveElements(cellElems, this.slider);
        this.viewport.appendChild(this.slider);
        this.element.appendChild(this.viewport);
        // get cells from children
        this.reloadCells();

        if (this.options.accessibility) {
            // allow element to focusable
            this.element.tabIndex = 0;
            // listen for key presses
            this.element.addEventListener('keydown', this);
        }

        this.emitEvent('activate');
        this.selectInitialIndex();
        // flag for initial activation, for using initialIndex
        this.isInitActivated = true;
        // ready event. #493
        this.dispatchEvent('ready');
    };

    // slider positions the cells
    proto._createSlider = function () {
        // slider element does all the positioning
        let slider = document.createElement('div');
        slider.className = 'aw_slide tsz_show-slider';
        slider.style[this.originSide] = 0;
        this.slider = slider;
    };

    proto._filterFindCellElements = function (elems) {
        return utils.filterFindElements(elems, this.options.cellSelector);
    };

    // goes through all children
    proto.reloadCells = function () {
        // collection of item elements
        this.cells = this._makeCells(this.slider.children);
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
    };

    /**
     * turn elements into tzs_show.Cells
     * @param {Array or NodeList or HTMLElement} elems
     * @returns {Array} items - collection of new tzs_show Cells
     */
    proto._makeCells = function (elems) {
        let cellElems = this._filterFindCellElements(elems);

        // create new tzs_show for collection
        let cells = cellElems.map(function (cellElem) {
            return new Cell(cellElem, this);
        }, this);

        return cells;
    };

    proto.getLastCell = function () {
        return this.cells[this.cells.length - 1];
    };

    proto.getLastSlide = function () {
        return this.slides[this.slides.length - 1];
    };

    // positions all cells
    proto.positionCells = function () {
        // size all cells
        this._sizeCells(this.cells);
        // position all cells
        this._positionCells(0);
    };

    /**
     * position certain cells
     * @param {Integer} index - which cell to start with
     */
    proto._positionCells = function (index) {
        index = index || 0;
        // also measure maxCellHeight
        // start 0 if positioning all cells
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        let cellX = 0;
        // get cellX
        if (index > 0) {
            let startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
        }
        let len = this.cells.length;
        for (let i = index; i < len; i++) {
            let cell = this.cells[i];
            cell.setPosition(cellX);
            cellX += cell.size.outerWidth;
            this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
        }
        // keep track of cellX for wrap-around
        this.slideableWidth = cellX;
        // slides
        this.updateSlides();
        // contain slides target
        this._containSlides();
        // update slidesWidth
        this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
    };

    /**
     * cell.getSize() on multiple cells
     * @param {Array} cells
     */
    proto._sizeCells = function (cells) {
        cells.forEach(function (cell) {
            cell.getSize();
        });
    };

    // --------------------------  -------------------------- //

    proto.updateSlides = function () {
        this.slides = [];
        if (!this.cells.length) {
            return;
        }

        let slide = new Slide(this);
        this.slides.push(slide);
        let isOriginLeft = this.originSide == 'left';
        let nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

        let canCellFit = this._getCanCellFit();

        this.cells.forEach(function (cell, i) {
            // just add cell if first cell in slide
            if (!slide.cells.length) {
                slide.addCell(cell);
                return;
            }

            let slideWidth = (slide.outerWidth - slide.firstMargin) +
                (cell.size.outerWidth - cell.size[nextMargin]);

            if (canCellFit.call(this, i, slideWidth)) {
                slide.addCell(cell);
            } else {
                // doesn't fit, new slide
                slide.updateTarget();

                slide = new Slide(this);
                this.slides.push(slide);
                slide.addCell(cell);
            }
        }, this);
        // last slide
        slide.updateTarget();
        // update .selectedSlide
        this.updateSelectedSlide();
    };

    proto._getCanCellFit = function () {
        let groupCells = this.options.groupCells;
        if (!groupCells) {
            return function () {
                return false;
            };
        } else if (typeof groupCells == 'number') {
            // group by number. 3 -> [0,1,2], [3,4,5], ...
            let number = parseInt(groupCells, 10);
            return function (i) {
                return (i % number) !== 0;
            };
        }
        // default, group by width of slide
        // parse '75%
        let percentMatch = typeof groupCells == 'string' &&
            groupCells.match(/^(\d+)%$/);
        let percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
        return function (i, slideWidth) {
            return slideWidth <= (this.size.innerWidth + 1) * percent;
        };
    };

    // alias _init for jQuery plugin .tzs_show()
    proto._init =
        proto.reposition = function () {
            this.positionCells();
            this.positionSliderAtSelected();
        };

    proto.getSize = function () {
        this.size = getSize(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };

    let cellAlignShorthands = {
        // cell align, then based on origin side
        center: {
            left: 0.5,
            right: 0.5
        },
        left: {
            left: 0,
            right: 1
        },
        right: {
            right: 0,
            left: 1
        }
    };

    proto.setCellAlign = function () {
        let shorthand = cellAlignShorthands[this.options.cellAlign];
        this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
    };

    proto.setGallerySize = function () {
        if (this.options.setGallerySize) {
            let height = this.options.adaptiveHeight && this.selectedSlide ?
                this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = height + 'px';
        }
    };

    proto._getWrapShiftCells = function () {
        // only for wrap-around
        if (!this.options.wrapAround) {
            return;
        }
        // unshift previous cells
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        // get before cells
        // initial gap
        let gapX = this.cursorPosition;
        let cellIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
        // get after cells
        // ending gap between last cell and end of gallery viewport
        gapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells(gapX, 0, 1);
    };

    proto._getGapCells = function (gapX, cellIndex, increment) {
        // keep adding cells until the cover the initial gap
        let cells = [];
        while (gapX > 0) {
            let cell = this.cells[cellIndex];
            if (!cell) {
                break;
            }
            cells.push(cell);
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
        }
        return cells;
    };

    // ----- contain ----- //

    // contain cell targets so no excess sliding
    proto._containSlides = function () {
        if (!this.options.contain || this.options.wrapAround || !this.cells.length) {
            return;
        }
        let isRightToLeft = this.options.rightToLeft;
        let beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
        let endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
        let contentWidth = this.slideableWidth - this.getLastCell().size[endMargin];
        // content is less than gallery size
        let isContentSmaller = contentWidth < this.size.innerWidth;
        // bounds
        let beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
        let endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
        // contain each cell target
        this.slides.forEach(function (slide) {
            if (isContentSmaller) {
                // all cells fit inside gallery
                slide.target = contentWidth * this.cellAlign;
            } else {
                // contain to bounds
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
            }
        }, this);
    };

    // -----  ----- //

    /**
     * emits events via eventEmitter and jQuery events
     * @param {String} type - name of event
     * @param {Event} event - original event
     * @param {Array} args - extra arguments
     */
    proto.dispatchEvent = function (type, event, args) {
        let emitArgs = event ? [event].concat(args) : args;
        this.emitEvent(type, emitArgs);

        if (awJq && this.$element) {
            // default trigger with type if no event
            type += this.options.namespaceJQueryEvents ? '.tzs_show' : '';
            let $event = type;
            if (event) {
                // create jQuery event
                let jQEvent = awJq.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
            }
            this.$element.trigger($event, args);
        }
    };

    // -------------------------- select -------------------------- //

    /**
     * @param {Integer} index - index of the slide
     * @param {Boolean} isWrap - will wrap-around to last/first if at the end
     * @param {Boolean} isInstant - will immediately set position at selected cell
     */
    proto.select = function (index, isWrap, isInstant) {
        if (!this.isActive) {
            return;
        }
        index = parseInt(index, 10);
        this._wrapSelect(index);

        if (this.options.wrapAround || isWrap) {
            index = utils.modulo(index, this.slides.length);
        }
        // bail if invalid index
        if (!this.slides[index]) {
            return;
        }
        let prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) {
            this.positionSliderAtSelected();
        } else {
            this.startAnimation();
        }
        if (this.options.adaptiveHeight) {
            this.setGallerySize();
        }
        // events
        this.dispatchEvent('select', null, [index]);
        // change event if new index
        if (index != prevIndex) {
            this.dispatchEvent('change', null, [index]);
        }
        // old v1 event name, remove in v3
        this.dispatchEvent('cellSelect');
    };

    // wraps position for wrapAround, to move to closest slide. #113
    proto._wrapSelect = function (index) {
        let len = this.slides.length;
        let isWrapping = this.options.wrapAround && len > 1;
        if (!isWrapping) {
            return index;
        }
        let wrapIndex = utils.modulo(index, len);
        // go to shortest
        let delta = Math.abs(wrapIndex - this.selectedIndex);
        let backWrapDelta = Math.abs((wrapIndex + len) - this.selectedIndex);
        let forewardWrapDelta = Math.abs((wrapIndex - len) - this.selectedIndex);
        if (!this.isDragSelect && backWrapDelta < delta) {
            index += len;
        } else if (!this.isDragSelect && forewardWrapDelta < delta) {
            index -= len;
        }
        // wrap position so slider is within normal area
        if (index < 0) {
            this.x -= this.slideableWidth;
        } else if (index >= len) {
            this.x += this.slideableWidth;
        }
    };

    proto.previous = function (isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
    };

    proto.next = function (isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
    };

    proto.updateSelectedSlide = function () {
        let slide = this.slides[this.selectedIndex];
        // selectedIndex could be outside of slides, if triggered before resize()
        if (!slide) {
            return;
        }
        // unselect previous selected slide
        this.unselectSelectedSlide();
        // update new selected slide
        this.selectedSlide = slide;
        slide.select();
        this.selectedCells = slide.cells;
        this.selectedElements = slide.getCellElements();
        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
        // Remove in v3?
        this.selectedCell = slide.cells[0];
        this.selectedElement = this.selectedElements[0];
    };

    proto.unselectSelectedSlide = function () {
        if (this.selectedSlide) {
            this.selectedSlide.unselect();
        }
    };

    proto.selectInitialIndex = function () {
        let initialIndex = this.options.initialIndex;
        // already activated, select previous selectedIndex
        if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
        }
        // select with selector string
        if (initialIndex && typeof initialIndex == 'string') {
            let cell = this.queryCell(initialIndex);
            if (cell) {
                this.selectCell(initialIndex, false, true);
                return;
            }
        }

        let index = 0;
        // select with number
        if (initialIndex && this.slides[initialIndex]) {
            index = initialIndex;
        }
        // select instantly
        this.select(index, false, true);
    };

    /**
     * select slide from number or cell element
     * @param {Element or Number} elem
     */
    proto.selectCell = function (value, isWrap, isInstant) {
        // get cell
        let cell = this.queryCell(value);
        if (!cell) {
            return;
        }

        let index = this.getCellSlideIndex(cell);
        this.select(index, isWrap, isInstant);
    };

    proto.getCellSlideIndex = function (cell) {
        // get index of slides that has cell
        for (let i = 0; i < this.slides.length; i++) {
            let slide = this.slides[i];
            let index = slide.cells.indexOf(cell);
            if (index != -1) {
                return i;
            }
        }
    };

    // -------------------------- get cells -------------------------- //

    /**
     * get tzs_show.Cell, given an Element
     * @param {Element} elem
     * @returns {tzs_show.Cell} item
     */
    proto.getCell = function (elem) {
        // loop through cells to get the one that matches
        for (let i = 0; i < this.cells.length; i++) {
            let cell = this.cells[i];
            if (cell.element == elem) {
                return cell;
            }
        }
    };

    /**
     * get collection of tzs_show.Cells, given Elements
     * @param {Element, Array, NodeList} elems
     * @returns {Array} cells - tzs_show.Cells
     */
    proto.getCells = function (elems) {
        elems = utils.makeArray(elems);
        let cells = [];
        elems.forEach(function (elem) {
            let cell = this.getCell(elem);
            if (cell) {
                cells.push(cell);
            }
        }, this);
        return cells;
    };

    /**
     * get cell elements
     * @returns {Array} cellElems
     */
    proto.getCellElements = function () {
        return this.cells.map(function (cell) {
            return cell.element;
        });
    };

    /**
     * get parent cell from an element
     * @param {Element} elem
     * @returns {Flickit.Cell} cell
     */
    proto.getParentCell = function (elem) {
        // first check if elem is cell
        let cell = this.getCell(elem);
        if (cell) {
            return cell;
        }
        // try to get parent cell elem
        elem = utils.getParent(elem, '.tzs_show-slider > *');
        return this.getCell(elem);
    };

    /**
     * get cells adjacent to a slide
     * @param {Integer} adjCount - number of adjacent slides
     * @param {Integer} index - index of slide to start
     * @returns {Array} cells - array of tzs_show.Cells
     */
    proto.getAdjacentCellElements = function (adjCount, index) {
        if (!adjCount) {
            return this.selectedSlide.getCellElements();
        }
        index = index === undefined ? this.selectedIndex : index;

        let len = this.slides.length;
        if (1 + (adjCount * 2) >= len) {
            return this.getCellElements();
        }

        let cellElems = [];
        for (let i = index - adjCount; i <= index + adjCount; i++) {
            let slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
            let slide = this.slides[slideIndex];
            if (slide) {
                cellElems = cellElems.concat(slide.getCellElements());
            }
        }
        return cellElems;
    };

    /**
     * select slide from number or cell element
     * @param {Element, Selector String, or Number} selector
     */
    proto.queryCell = function (selector) {
        if (typeof selector == 'number') {
            // use number as index
            return this.cells[selector];
        }
        if (typeof selector == 'string') {
            // do not select invalid selectors from hash: #123, #/. #791
            if (selector.match(/^[#\.]?[\d\/]/)) {
                return;
            }
            // use string as selector, get element
            selector = this.element.querySelector(selector);
        }
        // get cell from element
        return this.getCell(selector);
    };

    // -------------------------- events -------------------------- //

    proto.uiChange = function () {
        this.emitEvent('uiChange');
    };

    // keep focus on element when child UI elements are clicked
    proto.childUIPointerDown = function (event) {
        // HACK iOS does not allow touch events to bubble up?!
        if (event.type != 'touchstart') {
            event.preventDefault();
        }
        this.focus();
    };

    // ----- resize ----- //

    proto.onresize = function () {
        this.watchCSS();
        this.resize();
    };

    utils.debounceMethod(tzs_show, 'onresize', 150);

    proto.resize = function () {
        if (!this.isActive) {
            return;
        }
        this.getSize();
        // wrap values
        if (this.options.wrapAround) {
            this.x = utils.modulo(this.x, this.slideableWidth);
        }
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
        this.emitEvent('resize');
        // update selected index for group slides, instant
        // TODO: position can be lost between groups of letious numbers
        let selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
    };

    // watches the :after property, activates/deactivates
    proto.watchCSS = function () {
        let watchOption = this.options.watchCSS;
        if (!watchOption) {
            return;
        }

        let afterContent = getComputedStyle(this.element, ':after').content;
        // activate if :after { content: 'tzs_show' }
        if (afterContent.indexOf('tzs_show') != -1) {
            this.activate();
        } else {
            this.deactivate();
        }
    };

    // ----- keydown ----- //

    // go previous/next if left/right keys pressed
    proto.onkeydown = function (event) {
        // only work if element is in focus
        let isNotFocused = document.activeElement && document.activeElement != this.element;
        if (!this.options.accessibility || isNotFocused) {
            return;
        }

        let handler = tzs_show.keyboardHandlers[event.keyCode];
        if (handler) {
            handler.call(this);
        }
    };

    tzs_show.keyboardHandlers = {
        // left arrow
        37: function () {
            let leftMethod = this.options.rightToLeft ? 'next' : 'previous';
            this.uiChange();
            this[leftMethod]();
        },
        // right arrow
        39: function () {
            let rightMethod = this.options.rightToLeft ? 'previous' : 'next';
            this.uiChange();
            this[rightMethod]();
        },
    };

    // ----- focus ----- //

    proto.focus = function () {
        // TODO remove scrollTo once focus options gets more support
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Browser_compatibility
        let prevScrollY = window.pageYOffset;
        this.element.focus({ preventScroll: true });
        // hack to fix scroll jump after focus, #76
        if (window.pageYOffset != prevScrollY) {
            window.scrollTo(window.pageXOffset, prevScrollY);
        }
    };

    // -------------------------- destroy -------------------------- //

    // deactivate all tzs_show functionality, but keep stuff available
    proto.deactivate = function () {
        if (!this.isActive) {
            return;
        }
        this.element.classList.remove('tzs_show-enabled');
        this.element.classList.remove('tzs_show-rtl');
        this.unselectSelectedSlide();
        // destroy cells
        this.cells.forEach(function (cell) {
            cell.destroy();
        });
        this.element.removeChild(this.viewport);
        // move child elements back into element
        moveElements(this.slider.children, this.element);
        if (this.options.accessibility) {
            this.element.removeAttribute('tabIndex');
            this.element.removeEventListener('keydown', this);
        }
        // set flags
        this.isActive = false;
        this.emitEvent('deactivate');
    };

    proto.destroy = function () {
        this.deactivate();
        window.removeEventListener('resize', this);
        this.allOff();
        this.emitEvent('destroy');
        if (awJq && this.$element) {
            awJq.removeData(this.element, 'tzs_show');
        }
        delete this.element.tzs_showGUID;
        delete instances[this.guid];
    };

    // -------------------------- prototype -------------------------- //

    utils.extend(proto, animatePrototype);

    // -------------------------- extras -------------------------- //

    /**
     * get tzs_show instance from element
     * @param {Element} elem
     * @returns {tzs_show}
     */
    tzs_show.data = function (elem) {
        elem = utils.getQueryElement(elem);
        let id = elem && elem.tzs_showGUID;
        return id && instances[id];
    };

    utils.htmlInit(tzs_show, 'tzs_show');

    if (awJq && awJq.bridget) {
        awJq.bridget('tzs_show', tzs_show);
    }

    // set internal jQuery, for Webpack + jQuery v3, #478
    tzs_show.setJQuery = function (awJq) {
        jQuery = awJq;
    };

    tzs_show.Cell = Cell;
    tzs_show.Slide = Slide;

    return tzs_show;

}));

/*!
 * Unipointer v2.3.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

(function (window, factory) {
    // universal module definition
    /* jshint strict: false */ /*global define, module, require */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('unipointer/unipointer', [
            'ev-emitter/ev-emitter'
        ], function (EvEmitter) {
            return factory(window, EvEmitter);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('ev-emitter')
        );
    } else {
        // browser global
        window.Unipointer = factory(
            window,
            window.EvEmitter
        );
    }

}(window, function factory(window, EvEmitter) {



    function noop() { }

    function Unipointer() { }

    // inherit EvEmitter
    let proto = Unipointer.prototype = Object.create(EvEmitter.prototype);

    proto.bindStartEvent = function (elem) {
        this._bindStartEvent(elem, true);
    };

    proto.unbindStartEvent = function (elem) {
        this._bindStartEvent(elem, false);
    };

    /**
     * Add or remove start event
     * @param {Boolean} isAdd - remove if falsey
     */
    proto._bindStartEvent = function (elem, isAdd) {
        // munge isAdd, default to true
        isAdd = isAdd === undefined ? true : isAdd;
        let bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

        // default to mouse events
        let startEvent = 'mousedown';
        if (window.PointerEvent) {
            // Pointer Events
            startEvent = 'pointerdown';
        } else if ('ontouchstart' in window) {
            // Touch Events. iOS Safari
            startEvent = 'touchstart';
        }
        elem[bindMethod](startEvent, this);
    };

    // trigger handler methods for events
    proto.handleEvent = function (event) {
        let method = 'on' + event.type;
        if (this[method]) {
            this[method](event);
        }
    };

    // returns the touch that we're keeping track of
    proto.getTouch = function (touches) {
        for (let i = 0; i < touches.length; i++) {
            let touch = touches[i];
            if (touch.identifier == this.pointerIdentifier) {
                return touch;
            }
        }
    };

    // ----- start event ----- //

    proto.onmousedown = function (event) {
        // dismiss clicks from right or middle buttons
        let button = event.button;
        if (button && (button !== 0 && button !== 1)) {
            return;
        }
        this._pointerDown(event, event);
    };

    proto.ontouchstart = function (event) {
        this._pointerDown(event, event.changedTouches[0]);
    };

    proto.onpointerdown = function (event) {
        this._pointerDown(event, event);
    };

    /**
     * pointer start
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto._pointerDown = function (event, pointer) {
        // dismiss right click and other pointers
        // button = 0 is okay, 1-4 not
        if (event.button || this.isPointerDown) {
            return;
        }

        this.isPointerDown = true;
        // save pointer identifier to match up touch events
        this.pointerIdentifier = pointer.pointerId !== undefined ?
            // pointerId for pointer events, touch.indentifier for touch events
            pointer.pointerId : pointer.identifier;

        this.pointerDown(event, pointer);
    };

    proto.pointerDown = function (event, pointer) {
        this._bindPostStartEvents(event);
        this.emitEvent('pointerDown', [event, pointer]);
    };

    // hash of events to be bound after start event
    let postStartEvents = {
        mousedown: ['mousemove', 'mouseup'],
        touchstart: ['touchmove', 'touchend', 'touchcancel'],
        pointerdown: ['pointermove', 'pointerup', 'pointercancel'],
    };

    proto._bindPostStartEvents = function (event) {
        if (!event) {
            return;
        }
        // get proper events to match start event
        let events = postStartEvents[event.type];
        // bind events to node
        events.forEach(function (eventName) {
            window.addEventListener(eventName, this);
        }, this);
        // save these arguments
        this._boundPointerEvents = events;
    };

    proto._unbindPostStartEvents = function () {
        // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
        if (!this._boundPointerEvents) {
            return;
        }
        this._boundPointerEvents.forEach(function (eventName) {
            window.removeEventListener(eventName, this);
        }, this);

        delete this._boundPointerEvents;
    };

    // ----- move event ----- //

    proto.onmousemove = function (event) {
        this._pointerMove(event, event);
    };

    proto.onpointermove = function (event) {
        if (event.pointerId == this.pointerIdentifier) {
            this._pointerMove(event, event);
        }
    };

    proto.ontouchmove = function (event) {
        let touch = this.getTouch(event.changedTouches);
        if (touch) {
            this._pointerMove(event, touch);
        }
    };

    /**
     * pointer move
     * @param {Event} event
     * @param {Event or Touch} pointer
     * @private
     */
    proto._pointerMove = function (event, pointer) {
        this.pointerMove(event, pointer);
    };

    // public
    proto.pointerMove = function (event, pointer) {
        this.emitEvent('pointerMove', [event, pointer]);
    };

    // ----- end event ----- //


    proto.onmouseup = function (event) {
        this._pointerUp(event, event);
    };

    proto.onpointerup = function (event) {
        if (event.pointerId == this.pointerIdentifier) {
            this._pointerUp(event, event);
        }
    };

    proto.ontouchend = function (event) {
        let touch = this.getTouch(event.changedTouches);
        if (touch) {
            this._pointerUp(event, touch);
        }
    };

    /**
     * pointer up
     * @param {Event} event
     * @param {Event or Touch} pointer
     * @private
     */
    proto._pointerUp = function (event, pointer) {
        this._pointerDone();
        this.pointerUp(event, pointer);
    };

    // public
    proto.pointerUp = function (event, pointer) {
        this.emitEvent('pointerUp', [event, pointer]);
    };

    // ----- pointer done ----- //

    // triggered on pointer up & pointer cancel
    proto._pointerDone = function () {
        this._pointerReset();
        this._unbindPostStartEvents();
        this.pointerDone();
    };

    proto._pointerReset = function () {
        // reset properties
        this.isPointerDown = false;
        delete this.pointerIdentifier;
    };

    proto.pointerDone = noop;

    // ----- pointer cancel ----- //

    proto.onpointercancel = function (event) {
        if (event.pointerId == this.pointerIdentifier) {
            this._pointerCancel(event, event);
        }
    };

    proto.ontouchcancel = function (event) {
        let touch = this.getTouch(event.changedTouches);
        if (touch) {
            this._pointerCancel(event, touch);
        }
    };

    /**
     * pointer cancel
     * @param {Event} event
     * @param {Event or Touch} pointer
     * @private
     */
    proto._pointerCancel = function (event, pointer) {
        this._pointerDone();
        this.pointerCancel(event, pointer);
    };

    // public
    proto.pointerCancel = function (event, pointer) {
        this.emitEvent('pointerCancel', [event, pointer]);
    };

    // -----  ----- //

    // utility function for getting x/y coords from event
    Unipointer.getPointerPoint = function (pointer) {
        return {
            x: pointer.pageX,
            y: pointer.pageY
        };
    };

    // -----  ----- //

    return Unipointer;

}));

/*!
 * Unidragger v2.3.0
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

(function (window, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */

    if (typeof define == 'function' && define.amd) {
        // AMD
        define('unidragger/unidragger', [
            'unipointer/unipointer'
        ], function (Unipointer) {
            return factory(window, Unipointer);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('unipointer')
        );
    } else {
        // browser global
        window.Unidragger = factory(
            window,
            window.Unipointer
        );
    }

}(window, function factory(window, Unipointer) {



    // -------------------------- Unidragger -------------------------- //

    function Unidragger() { }

    // inherit Unipointer & EvEmitter
    let proto = Unidragger.prototype = Object.create(Unipointer.prototype);

    // ----- bind start ----- //

    proto.bindHandles = function () {
        this._bindHandles(true);
    };

    proto.unbindHandles = function () {
        this._bindHandles(false);
    };

    /**
     * Add or remove start event
     * @param {Boolean} isAdd
     */
    proto._bindHandles = function (isAdd) {
        // munge isAdd, default to true
        isAdd = isAdd === undefined ? true : isAdd;
        // bind each handle
        let bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
        let touchAction = isAdd ? this._touchActionValue : '';
        for (let i = 0; i < this.handles.length; i++) {
            let handle = this.handles[i];
            this._bindStartEvent(handle, isAdd);
            handle[bindMethod]('click', this);
            // touch-action: none to override browser touch gestures. metafizzy/tzs_show#540
            if (window.PointerEvent) {
                handle.style.touchAction = touchAction;
            }
        }
    };

    // prototype so it can be overwriteable by tzs_show
    proto._touchActionValue = 'none';

    // ----- start event ----- //

    /**
     * pointer start
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto.pointerDown = function (event, pointer) {
        let isOkay = this.okayPointerDown(event);
        if (!isOkay) {
            return;
        }
        // track start event position
        this.pointerDownPointer = pointer;

        event.preventDefault();
        this.pointerDownBlur();
        // bind move and end events
        this._bindPostStartEvents(event);
        this.emitEvent('pointerDown', [event, pointer]);
    };

    // nodes that have text fields
    let cursorNodes = {
        TEXTAREA: true,
        INPUT: true,
        SELECT: true,
        OPTION: true,
    };

    // input types that do not have text fields
    let clickTypes = {
        radio: true,
        checkbox: true,
        button: true,
        submit: true,
        image: true,
        file: true,
    };

    // dismiss inputs with text fields. tzs_show#403, tzs_show#404
    proto.okayPointerDown = function (event) {
        let isCursorNode = cursorNodes[event.target.nodeName];
        let isClickType = clickTypes[event.target.type];
        let isOkay = !isCursorNode || isClickType;
        if (!isOkay) {
            this._pointerReset();
        }
        return isOkay;
    };

    // kludge to blur previously focused input
    proto.pointerDownBlur = function () {
        let focused = document.activeElement;
        // do not blur body for IE10, metafizzy/tzs_show#117
        let canBlur = focused && focused.blur && focused != document.body;
        if (canBlur) {
            focused.blur();
        }
    };

    // ----- move event ----- //

    /**
     * drag move
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto.pointerMove = function (event, pointer) {
        let moveVector = this._dragPointerMove(event, pointer);
        this.emitEvent('pointerMove', [event, pointer, moveVector]);
        this._dragMove(event, pointer, moveVector);
    };

    // base pointer move logic
    proto._dragPointerMove = function (event, pointer) {
        let moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
        };
        // start drag if pointer has moved far enough to start drag
        if (!this.isDragging && this.hasDragStarted(moveVector)) {
            this._dragStart(event, pointer);
        }
        return moveVector;
    };

    // condition if pointer has moved far enough to start drag
    proto.hasDragStarted = function (moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
    };

    // ----- end event ----- //

    /**
     * pointer up
     * @param {Event} event
     * @param {Event or Touch} pointer
     */
    proto.pointerUp = function (event, pointer) {
        this.emitEvent('pointerUp', [event, pointer]);
        this._dragPointerUp(event, pointer);
    };

    proto._dragPointerUp = function (event, pointer) {
        if (this.isDragging) {
            this._dragEnd(event, pointer);
        } else {
            // pointer didn't move enough for drag to start
            this._staticClick(event, pointer);
        }
    };

    // -------------------------- drag -------------------------- //

    // dragStart
    proto._dragStart = function (event, pointer) {
        this.isDragging = true;
        // prevent clicks
        this.isPreventingClicks = true;
        this.dragStart(event, pointer);
    };

    proto.dragStart = function (event, pointer) {
        this.emitEvent('dragStart', [event, pointer]);
    };

    // dragMove
    proto._dragMove = function (event, pointer, moveVector) {
        // do not drag if not dragging yet
        if (!this.isDragging) {
            return;
        }

        this.dragMove(event, pointer, moveVector);
    };

    proto.dragMove = function (event, pointer, moveVector) {
        event.preventDefault();
        this.emitEvent('dragMove', [event, pointer, moveVector]);
    };

    // dragEnd
    proto._dragEnd = function (event, pointer) {
        // set flags
        this.isDragging = false;
        // re-enable clicking async
        setTimeout(function () {
            delete this.isPreventingClicks;
        }.bind(this));

        this.dragEnd(event, pointer);
    };

    proto.dragEnd = function (event, pointer) {
        this.emitEvent('dragEnd', [event, pointer]);
    };

    // ----- onclick ----- //

    // handle all clicks and prevent clicks when dragging
    proto.onclick = function (event) {
        if (this.isPreventingClicks) {
            event.preventDefault();
        }
    };

    // ----- staticClick ----- //

    // triggered after pointer down & up with no/tiny movement
    proto._staticClick = function (event, pointer) {
        // ignore emulated mouse up clicks
        if (this.isIgnoringMouseUp && event.type == 'mouseup') {
            return;
        }

        this.staticClick(event, pointer);

        // set flag for emulated clicks 300ms after touchend
        if (event.type != 'mouseup') {
            this.isIgnoringMouseUp = true;
            // reset flag after 300ms
            setTimeout(function () {
                delete this.isIgnoringMouseUp;
            }.bind(this), 400);
        }
    };

    proto.staticClick = function (event, pointer) {
        this.emitEvent('staticClick', [event, pointer]);
    };

    // ----- utils ----- //

    Unidragger.getPointerPoint = Unipointer.getPointerPoint;

    // -----  ----- //

    return Unidragger;

}));

// drag
(function (window, factory) {
    // universal module definition
    /* jshint strict: false */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('tzs_show/js/drag', [
            './tzs_show',
            'unidragger/unidragger',
            'fizzy-ui-utils/utils'
        ], function (tzs_show, Unidragger, utils) {
            return factory(window, tzs_show, Unidragger, utils);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('./tzs_show'),
            require('unidragger'),
            require('fizzy-ui-utils')
        );
    } else {
        // browser global
        window.tzs_show = factory(
            window,
            window.tzs_show,
            window.Unidragger,
            window.fizzyUIUtils
        );
    }

}(window, function factory(window, tzs_show, Unidragger, utils) {



    // ----- defaults ----- //

    utils.extend(tzs_show.defaults, {
        draggable: '>1',
        dragThreshold: 3,
    });

    // ----- create ----- //

    tzs_show.createMethods.push('_createDrag');

    // -------------------------- drag prototype -------------------------- //

    let proto = tzs_show.prototype;
    utils.extend(proto, Unidragger.prototype);
    proto._touchActionValue = 'pan-y';

    // --------------------------  -------------------------- //

    let isTouch = 'createTouch' in document;
    let isTouchmoveScrollCanceled = false;

    proto._createDrag = function () {
        this.on('activate', this.onActivateDrag);
        this.on('uiChange', this._uiChangeDrag);
        this.on('deactivate', this.onDeactivateDrag);
        this.on('cellChange', this.updateDraggable);
        // TODO updateDraggable on resize? if groupCells & slides change
        // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
        // #457, RubaXa/Sortable#973
        if (isTouch && !isTouchmoveScrollCanceled) {
            window.addEventListener('touchmove', function () { });
            isTouchmoveScrollCanceled = true;
        }
    };

    proto.onActivateDrag = function () {
        this.handles = [this.viewport];
        this.bindHandles();
        this.updateDraggable();
    };

    proto.onDeactivateDrag = function () {
        this.unbindHandles();
        this.element.classList.remove('is-draggable');
    };

    proto.updateDraggable = function () {
        // disable dragging if less than 2 slides. #278
        if (this.options.draggable == '>1') {
            this.isDraggable = this.slides.length > 1;
        } else {
            this.isDraggable = this.options.draggable;
        }
        if (this.isDraggable) {
            this.element.classList.add('is-draggable');
        } else {
            this.element.classList.remove('is-draggable');
        }
    };

    // backwards compatibility
    proto.bindDrag = function () {
        this.options.draggable = true;
        this.updateDraggable();
    };

    proto.unbindDrag = function () {
        this.options.draggable = false;
        this.updateDraggable();
    };

    proto._uiChangeDrag = function () {
        delete this.isFreeScrolling;
    };

    // -------------------------- pointer events -------------------------- //

    proto.pointerDown = function (event, pointer) {
        if (!this.isDraggable) {
            this._pointerDownDefault(event, pointer);
            return;
        }
        let isOkay = this.okayPointerDown(event);
        if (!isOkay) {
            return;
        }

        this._pointerDownPreventDefault(event);
        this.pointerDownFocus(event);
        // blur
        if (document.activeElement != this.element) {
            // do not blur if already focused
            this.pointerDownBlur();
        }

        // stop if it was moving
        this.dragX = this.x;
        this.viewport.classList.add('is-pointer-down');
        // track scrolling
        this.pointerDownScroll = getScrollPosition();
        window.addEventListener('scroll', this);

        this._pointerDownDefault(event, pointer);
    };

    // default pointerDown logic, used for staticClick
    proto._pointerDownDefault = function (event, pointer) {
        // track start event position
        // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY,
        };
        // bind move and end events
        this._bindPostStartEvents(event);
        this.dispatchEvent('pointerDown', event, [pointer]);
    };

    let focusNodes = {
        INPUT: true,
        TEXTAREA: true,
        SELECT: true,
    };

    proto.pointerDownFocus = function (event) {
        let isFocusNode = focusNodes[event.target.nodeName];
        if (!isFocusNode) {
            this.focus();
        }
    };

    proto._pointerDownPreventDefault = function (event) {
        let isTouchStart = event.type == 'touchstart';
        let isTouchPointer = event.pointerType == 'touch';
        let isFocusNode = focusNodes[event.target.nodeName];
        if (!isTouchStart && !isTouchPointer && !isFocusNode) {
            event.preventDefault();
        }
    };

    // ----- move ----- //

    proto.hasDragStarted = function (moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
    };

    // ----- up ----- //

    proto.pointerUp = function (event, pointer) {
        delete this.isTouchScrolling;
        this.viewport.classList.remove('is-pointer-down');
        this.dispatchEvent('pointerUp', event, [pointer]);
        this._dragPointerUp(event, pointer);
    };

    proto.pointerDone = function () {
        window.removeEventListener('scroll', this);
        delete this.pointerDownScroll;
    };

    // -------------------------- dragging -------------------------- //

    proto.dragStart = function (event, pointer) {
        if (!this.isDraggable) {
            return;
        }
        this.dragStartPosition = this.x;
        this.startAnimation();
        window.removeEventListener('scroll', this);
        this.dispatchEvent('dragStart', event, [pointer]);
    };

    proto.pointerMove = function (event, pointer) {
        let moveVector = this._dragPointerMove(event, pointer);
        this.dispatchEvent('pointerMove', event, [pointer, moveVector]);
        this._dragMove(event, pointer, moveVector);
    };

    proto.dragMove = function (event, pointer, moveVector) {
        if (!this.isDraggable) {
            return;
        }
        event.preventDefault();

        this.previousDragX = this.dragX;
        // reverse if right-to-left
        let direction = this.options.rightToLeft ? -1 : 1;
        if (this.options.wrapAround) {
            // wrap around move. #589
            moveVector.x = moveVector.x % this.slideableWidth;
        }
        let dragX = this.dragStartPosition + moveVector.x * direction;

        if (!this.options.wrapAround && this.slides.length) {
            // slow drag
            let originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            let endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }

        this.dragX = dragX;

        this.dragMoveTime = new Date();
        this.dispatchEvent('dragMove', event, [pointer, moveVector]);
    };

    proto.dragEnd = function (event, pointer) {
        if (!this.isDraggable) {
            return;
        }
        if (this.options.freeScroll) {
            this.isFreeScrolling = true;
        }
        // set selectedIndex based on where flick will end up
        let index = this.dragEndRestingSelect();

        if (this.options.freeScroll && !this.options.wrapAround) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            let restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target &&
                -restingX < this.getLastSlide().target;
        } else if (!this.options.freeScroll && index == this.selectedIndex) {
            // boost selection if selected index has not changed
            index += this.dragEndBoostSelect();
        }
        delete this.previousDragX;
        // apply selection
        // TODO refactor this, selecting here feels weird
        // HACK, set flag so dragging stays in correct direction
        this.isDragSelect = this.options.wrapAround;
        this.select(index);
        delete this.isDragSelect;
        this.dispatchEvent('dragEnd', event, [pointer]);
    };

    proto.dragEndRestingSelect = function () {
        let restingX = this.getRestingPosition();
        // how far away from selected slide
        let distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        // get closet resting going up and going down
        let positiveResting = this._getClosestResting(restingX, distance, 1);
        let negativeResting = this._getClosestResting(restingX, distance, -1);
        // use closer resting for wrap-around
        let index = positiveResting.distance < negativeResting.distance ?
            positiveResting.index : negativeResting.index;
        return index;
    };

    /**
     * given resting X and distance to selected cell
     * get the distance and index of the closest cell
     * @param {Number} restingX - estimated post-flick resting position
     * @param {Number} distance - distance to selected cell
     * @param {Integer} increment - +1 or -1, going up or down
     * @returns {Object} - { distance: {Number}, index: {Integer} }
     */
    proto._getClosestResting = function (restingX, distance, increment) {
        let index = this.selectedIndex;
        let minDistance = Infinity;
        let condition = this.options.contain && !this.options.wrapAround ?
            // if contain, keep going if distance is equal to minDistance
            function (d, md) { return d <= md; } : function (d, md) { return d < md; };
        while (condition(distance, minDistance)) {
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) {
                break;
            }
            distance = Math.abs(distance);
        }
        return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
        };
    };

    /**
     * measure distance between x and a slide target
     * @param {Number} x
     * @param {Integer} index - slide index
     */
    proto.getSlideDistance = function (x, index) {
        let len = this.slides.length;
        // wrap around if at least 2 slides
        let isWrapAround = this.options.wrapAround && len > 1;
        let slideIndex = isWrapAround ? utils.modulo(index, len) : index;
        let slide = this.slides[slideIndex];
        if (!slide) {
            return null;
        }
        // add distance for wrap-around slides
        let wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide.target + wrap);
    };

    proto.dragEndBoostSelect = function () {
        // do not boost if no previousDragX or dragMoveTime
        if (this.previousDragX === undefined || !this.dragMoveTime ||
            // or if drag was held for 100 ms
            new Date() - this.dragMoveTime > 100) {
            return 0;
        }

        let distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        let delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) {
            // boost to next if moving towards the right, and positive velocity
            return 1;
        } else if (distance < 0 && delta < 0) {
            // boost to previous if moving towards the left, and negative velocity
            return -1;
        }
        return 0;
    };

    // ----- staticClick ----- //

    proto.staticClick = function (event, pointer) {
        // get clickedCell, if cell was clicked
        let clickedCell = this.getParentCell(event.target);
        let cellElem = clickedCell && clickedCell.element;
        let cellIndex = clickedCell && this.cells.indexOf(clickedCell);
        this.dispatchEvent('staticClick', event, [pointer, cellElem, cellIndex]);
    };

    // ----- scroll ----- //

    proto.onscroll = function () {
        let scroll = getScrollPosition();
        let scrollMoveX = this.pointerDownScroll.x - scroll.x;
        let scrollMoveY = this.pointerDownScroll.y - scroll.y;
        // cancel click/tap if scroll is too much
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
            this._pointerDone();
        }
    };

    // ----- utils ----- //

    function getScrollPosition() {
        return {
            x: window.pageXOffset,
            y: window.pageYOffset
        };
    }

    // -----  ----- //

    return tzs_show;

}));

// prev/next buttons
(function (window, factory) {
    // universal module definition
    /* jshint strict: false */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('tzs_show/js/prev-next-button', [
            './tzs_show',
            'unipointer/unipointer',
            'fizzy-ui-utils/utils'
        ], function (tzs_show, Unipointer, utils) {
            return factory(window, tzs_show, Unipointer, utils);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('./tzs_show'),
            require('unipointer'),
            require('fizzy-ui-utils')
        );
    } else {
        // browser global
        factory(
            window,
            window.tzs_show,
            window.Unipointer,
            window.fizzyUIUtils
        );
    }

}(window, function factory(window, tzs_show, Unipointer, utils) {
    'use strict';

    let svgURI = 'http://www.w3.org/2000/svg';

    // -------------------------- PrevNextButton -------------------------- //

    function PrevNextButton(direction, parent) {
        this.direction = direction;
        this.parent = parent;
        this._create();
    }

    PrevNextButton.prototype = Object.create(Unipointer.prototype);

    PrevNextButton.prototype._create = function () {
        // properties
        this.isEnabled = true;
        this.isPrevious = this.direction == -1;
        let leftDirection = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == leftDirection;

        let element = this.element = document.createElement('button');
        element.className = 'tzs_show-button tzs_show-prev-next-button';
        element.className += this.isPrevious ? ' previous' : ' next';
        // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
        element.setAttribute('type', 'button');
        // init as disabled
        this.disable();

        element.setAttribute('aria-label', this.isPrevious ? 'Previous' : 'Next');

        // create arrow
        let svg = this.createSVG();
        element.appendChild(svg);
        // events
        this.parent.on('select', this.update.bind(this));
        this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
    };

    PrevNextButton.prototype.activate = function () {
        this.bindStartEvent(this.element);
        this.element.addEventListener('click', this);
        // add to DOM
        this.parent.element.appendChild(this.element);
    };

    PrevNextButton.prototype.deactivate = function () {
        // remove from DOM
        this.parent.element.removeChild(this.element);
        // click events
        this.unbindStartEvent(this.element);
        this.element.removeEventListener('click', this);
    };

    PrevNextButton.prototype.createSVG = function () {
        let svg = document.createElementNS(svgURI, 'svg');
        svg.setAttribute('class', 'tzs_show-button-icon');
        svg.setAttribute('viewBox', '0 0 100 100');
        let path = document.createElementNS(svgURI, 'path');
        let pathMovements = getArrowMovements(this.parent.options.arrowShape);
        path.setAttribute('d', pathMovements);
        path.setAttribute('class', 'arrow');
        // rotate arrow
        if (!this.isLeft) {
            path.setAttribute('transform', 'translate(100, 100) rotate(180) ');
        }
        svg.appendChild(path);
        return svg;
    };

    // get SVG path movmement
    function getArrowMovements(shape) {
        // use shape as movement if string
        if (typeof shape == 'string') {
            return shape;
        }
        // create movement string
        return 'M ' + shape.x0 + ',50' +
            ' L ' + shape.x1 + ',' + (shape.y1 + 50) +
            ' L ' + shape.x2 + ',' + (shape.y2 + 50) +
            ' L ' + shape.x3 + ',50 ' +
            ' L ' + shape.x2 + ',' + (50 - shape.y2) +
            ' L ' + shape.x1 + ',' + (50 - shape.y1) +
            ' Z';
    }

    PrevNextButton.prototype.handleEvent = utils.handleEvent;

    PrevNextButton.prototype.onclick = function () {
        if (!this.isEnabled) {
            return;
        }
        this.parent.uiChange();
        let method = this.isPrevious ? 'previous' : 'next';
        this.parent[method]();
    };

    // -----  ----- //

    PrevNextButton.prototype.enable = function () {
        if (this.isEnabled) {
            return;
        }
        this.element.disabled = false;
        this.isEnabled = true;
    };

    PrevNextButton.prototype.disable = function () {
        if (!this.isEnabled) {
            return;
        }
        this.element.disabled = true;
        this.isEnabled = false;
    };

    PrevNextButton.prototype.update = function () {
        // index of first or last slide, if previous or next
        let slides = this.parent.slides;
        // enable is wrapAround and at least 2 slides
        if (this.parent.options.wrapAround && slides.length > 1) {
            this.enable();
            return;
        }
        let lastIndex = slides.length ? slides.length - 1 : 0;
        let boundIndex = this.isPrevious ? 0 : lastIndex;
        let method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
        this[method]();
    };

    PrevNextButton.prototype.destroy = function () {
        this.deactivate();
        this.allOff();
    };

    // -------------------------- tzs_show prototype -------------------------- //

    utils.extend(tzs_show.defaults, {
        prevNextButtons: true,
        arrowShape: {
            x0: 10,
            x1: 60, y1: 50,
            x2: 70, y2: 40,
            x3: 30
        }
    });

    tzs_show.createMethods.push('_createPrevNextButtons');
    let proto = tzs_show.prototype;

    proto._createPrevNextButtons = function () {
        if (!this.options.prevNextButtons) {
            return;
        }

        this.prevButton = new PrevNextButton(-1, this);
        this.nextButton = new PrevNextButton(1, this);

        this.on('activate', this.activatePrevNextButtons);
    };

    proto.activatePrevNextButtons = function () {
        this.prevButton.activate();
        this.nextButton.activate();
        this.on('deactivate', this.deactivatePrevNextButtons);
    };

    proto.deactivatePrevNextButtons = function () {
        this.prevButton.deactivate();
        this.nextButton.deactivate();
        this.off('deactivate', this.deactivatePrevNextButtons);
    };

    // --------------------------  -------------------------- //

    tzs_show.PrevNextButton = PrevNextButton;

    return tzs_show;

}));

// page dots
(function (window, factory) {
    // universal module definition
    /* jshint strict: false */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('tzs_show/js/page-dots', [
            './tzs_show',
            'unipointer/unipointer',
            'fizzy-ui-utils/utils'
        ], function (tzs_show, Unipointer, utils) {
            return factory(window, tzs_show, Unipointer, utils);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('./tzs_show'),
            require('unipointer'),
            require('fizzy-ui-utils')
        );
    } else {
        // browser global
        factory(
            window,
            window.tzs_show,
            window.Unipointer,
            window.fizzyUIUtils
        );
    }

}(window, function factory(window, tzs_show, Unipointer, utils) {

    // -------------------------- PageDots -------------------------- //



    function PageDots(parent) {
        this.parent = parent;
        this._create();
    }

    PageDots.prototype = Object.create(Unipointer.prototype);

    PageDots.prototype._create = function () {
        // create holder element
        this.holder = document.createElement('ol');
        this.holder.className = 'tzs_show-page-dots';
        // create dots, array of elements
        this.dots = [];
        // events
        this.handleClick = this.onClick.bind(this);
        this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
    };

    PageDots.prototype.activate = function () {
        this.setDots();
        this.holder.addEventListener('click', this.handleClick);
        this.bindStartEvent(this.holder);
        // add to DOM
        this.parent.element.appendChild(this.holder);
    };

    PageDots.prototype.deactivate = function () {
        this.holder.removeEventListener('click', this.handleClick);
        this.unbindStartEvent(this.holder);
        // remove from DOM
        this.parent.element.removeChild(this.holder);
    };

    PageDots.prototype.setDots = function () {
        // get difference between number of slides and number of dots
        let delta = this.parent.slides.length - this.dots.length;
        if (delta > 0) {
            this.addDots(delta);
        } else if (delta < 0) {
            this.removeDots(-delta);
        }
    };

    PageDots.prototype.addDots = function (count) {
        let fragment = document.createDocumentFragment();
        let newDots = [];
        let length = this.dots.length;
        let max = length + count;

        for (let i = length; i < max; i++) {
            let dot = document.createElement('li');
            dot.className = 'aw_dot';
            dot.setAttribute('aria-label', 'Page dot ' + (i + 1));
            fragment.appendChild(dot);
            newDots.push(dot);
        }

        this.holder.appendChild(fragment);
        this.dots = this.dots.concat(newDots);
    };

    PageDots.prototype.removeDots = function (count) {
        // remove from this.dots collection
        let removeDots = this.dots.splice(this.dots.length - count, count);
        // remove from DOM
        removeDots.forEach(function (dot) {
            this.holder.removeChild(dot);
        }, this);
    };

    PageDots.prototype.updateSelected = function () {
        // remove selected class on previous
        if (this.selectedDot) {
            this.selectedDot.className = 'aw_dot';
            this.selectedDot.removeAttribute('aria-current');
        }
        // don't proceed if no dots
        if (!this.dots.length) {
            return;
        }
        this.selectedDot = this.dots[this.parent.selectedIndex];
        this.selectedDot.className = 'aw_dot is-selected';
        this.selectedDot.setAttribute('aria-current', 'step');
    };

    PageDots.prototype.onTap = // old method name, backwards-compatible
        PageDots.prototype.onClick = function (event) {
            let target = event.target;
            // only care about dot clicks
            if (target.nodeName != 'LI') {
                return;
            }

            this.parent.uiChange();
            let index = this.dots.indexOf(target);
            this.parent.select(index);
        };

    PageDots.prototype.destroy = function () {
        this.deactivate();
        this.allOff();
    };

    tzs_show.PageDots = PageDots;

    // -------------------------- tzs_show -------------------------- //

    utils.extend(tzs_show.defaults, {
        pageDots: true
    });

    tzs_show.createMethods.push('_createPageDots');

    let proto = tzs_show.prototype;

    proto._createPageDots = function () {
        if (!this.options.pageDots) {
            return;
        }
        this.pageDots = new PageDots(this);
        // events
        this.on('activate', this.activatePageDots);
        this.on('select', this.updateSelectedPageDots);
        this.on('cellChange', this.updatePageDots);
        this.on('resize', this.updatePageDots);
        this.on('deactivate', this.deactivatePageDots);
    };

    proto.activatePageDots = function () {
        this.pageDots.activate();
    };

    proto.updateSelectedPageDots = function () {
        this.pageDots.updateSelected();
    };

    proto.updatePageDots = function () {
        this.pageDots.setDots();
    };

    proto.deactivatePageDots = function () {
        this.pageDots.deactivate();
    };

    // -----  ----- //

    tzs_show.PageDots = PageDots;

    return tzs_show;

}));

// player & autoPlay
(function (window, factory) {
    // universal module definition
    /* jshint strict: false */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('tzs_show/js/player', [
            'ev-emitter/ev-emitter',
            'fizzy-ui-utils/utils',
            './tzs_show'
        ], function (EvEmitter, utils, tzs_show) {
            return factory(EvEmitter, utils, tzs_show);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('ev-emitter'),
            require('fizzy-ui-utils'),
            require('./tzs_show')
        );
    } else {
        // browser global
        factory(
            window.EvEmitter,
            window.fizzyUIUtils,
            window.tzs_show
        );
    }

}(window, function factory(EvEmitter, utils, tzs_show) {



    // -------------------------- Player -------------------------- //

    function Player(parent) {
        this.parent = parent;
        this.state = 'stopped';
        // visibility change event handler
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
    }

    Player.prototype = Object.create(EvEmitter.prototype);

    // start play
    Player.prototype.play = function () {
        if (this.state == 'playing') {
            return;
        }
        // do not play if page is hidden, start playing when page is visible
        let isPageHidden = document.hidden;
        if (isPageHidden) {
            document.addEventListener('visibilitychange', this.onVisibilityPlay);
            return;
        }

        this.state = 'playing';
        // listen to visibility change
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        // start ticking
        this.tick();
    };

    Player.prototype.tick = function () {
        // do not tick if not playing
        if (this.state != 'playing') {
            return;
        }

        let time = this.parent.options.autoPlay;
        // default to 3 seconds
        time = typeof time == 'number' ? time : 3000;
        let _this = this;
        // HACK: reset ticks if stopped and started within interval
        this.clear();
        this.timeout = setTimeout(function () {
            _this.parent.next(true);
            _this.tick();
        }, time);
    };

    Player.prototype.stop = function () {
        this.state = 'stopped';
        this.clear();
        // remove visibility change event
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    };

    Player.prototype.clear = function () {
        clearTimeout(this.timeout);
    };

    Player.prototype.pause = function () {
        if (this.state == 'playing') {
            this.state = 'paused';
            this.clear();
        }
    };

    Player.prototype.unpause = function () {
        // re-start play if paused
        if (this.state == 'paused') {
            this.play();
        }
    };

    // pause if page visibility is hidden, unpause if visible
    Player.prototype.visibilityChange = function () {
        let isPageHidden = document.hidden;
        this[isPageHidden ? 'pause' : 'unpause']();
    };

    Player.prototype.visibilityPlay = function () {
        this.play();
        document.removeEventListener('visibilitychange', this.onVisibilityPlay);
    };

    // -------------------------- tzs_show -------------------------- //

    utils.extend(tzs_show.defaults, {
        pauseAutoPlayOnHover: true
    });

    tzs_show.createMethods.push('_createPlayer');
    let proto = tzs_show.prototype;

    proto._createPlayer = function () {
        this.player = new Player(this);

        this.on('activate', this.activatePlayer);
        this.on('uiChange', this.stopPlayer);
        this.on('pointerDown', this.stopPlayer);
        this.on('deactivate', this.deactivatePlayer);
    };

    proto.activatePlayer = function () {
        if (!this.options.autoPlay) {
            return;
        }
        this.player.play();
        this.element.addEventListener('mouseenter', this);
    };

    // Player API, don't hate the ... thanks I know where the door is

    proto.playPlayer = function () {
        this.player.play();
    };

    proto.stopPlayer = function () {
        this.player.stop();
    };

    proto.pausePlayer = function () {
        this.player.pause();
    };

    proto.unpausePlayer = function () {
        this.player.unpause();
    };

    proto.deactivatePlayer = function () {
        this.player.stop();
        this.element.removeEventListener('mouseenter', this);
    };

    // ----- mouseenter/leave ----- //

    // pause auto-play on hover
    proto.onmouseenter = function () {
        if (!this.options.pauseAutoPlayOnHover) {
            return;
        }
        this.player.pause();
        this.element.addEventListener('mouseleave', this);
    };

    // resume auto-play on hover off
    proto.onmouseleave = function () {
        this.player.unpause();
        this.element.removeEventListener('mouseleave', this);
    };

    // -----  ----- //

    tzs_show.Player = Player;

    return tzs_show;

}));

// add, remove cell
(function (window, factory) {
    // universal module definition
    /* jshint strict: false */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('tzs_show/js/add-remove-cell', [
            './tzs_show',
            'fizzy-ui-utils/utils'
        ], function (tzs_show, utils) {
            return factory(window, tzs_show, utils);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('./tzs_show'),
            require('fizzy-ui-utils')
        );
    } else {
        // browser global
        factory(
            window,
            window.tzs_show,
            window.fizzyUIUtils
        );
    }

}(window, function factory(window, tzs_show, utils) {



    // append cells to a document fragment
    function getCellsFragment(cells) {
        let fragment = document.createDocumentFragment();
        cells.forEach(function (cell) {
            fragment.appendChild(cell.element);
        });
        return fragment;
    }

    // -------------------------- add/remove cell prototype -------------------------- //

    let proto = tzs_show.prototype;

    /**
     * Insert, prepend, or append cells
     * @param {Element, Array, NodeList} elems
     * @param {Integer} index
     */
    proto.insert = function (elems, index) {
        let cells = this._makeCells(elems);
        if (!cells || !cells.length) {
            return;
        }
        let len = this.cells.length;
        // default to append
        index = index === undefined ? len : index;
        // add cells with document fragment
        let fragment = getCellsFragment(cells);
        // append to slider
        let isAppend = index == len;
        if (isAppend) {
            this.slider.appendChild(fragment);
        } else {
            let insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
        }
        // add to this.cells
        if (index === 0) {
            // prepend, add to start
            this.cells = cells.concat(this.cells);
        } else if (isAppend) {
            // append, add to end
            this.cells = this.cells.concat(cells);
        } else {
            // insert in this.cells
            let endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
        }

        this._sizeCells(cells);
        this.cellChange(index, true);
    };

    proto.append = function (elems) {
        this.insert(elems, this.cells.length);
    };

    proto.prepend = function (elems) {
        this.insert(elems, 0);
    };

    /**
     * Remove cells
     * @param {Element, Array, NodeList} elems
     */
    proto.remove = function (elems) {
        let cells = this.getCells(elems);
        if (!cells || !cells.length) {
            return;
        }

        let minCellIndex = this.cells.length - 1;
        // remove cells from collection & DOM
        cells.forEach(function (cell) {
            cell.remove();
            let index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
        }, this);

        this.cellChange(minCellIndex, true);
    };

    /**
     * logic to be run after a cell's size changes
     * @param {Element} elem - cell's element
     */
    proto.cellSizeChange = function (elem) {
        let cell = this.getCell(elem);
        if (!cell) {
            return;
        }
        cell.getSize();

        let index = this.cells.indexOf(cell);
        this.cellChange(index);
    };

    /**
     * logic any time a cell is changed: added, removed, or size changed
     * @param {Integer} changedCellIndex - index of the changed cell, optional
     */
    proto.cellChange = function (changedCellIndex, isPositioningSlider) {
        let prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._getWrapShiftCells();
        this.setGallerySize();
        // update selectedIndex
        // try to maintain position & select previous selected element
        let cell = this.getCell(prevSelectedElem);
        if (cell) {
            this.selectedIndex = this.getCellSlideIndex(cell);
        }
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);

        this.emitEvent('cellChange', [changedCellIndex]);
        // position slider
        this.select(this.selectedIndex);
        // do not position slider after lazy load
        if (isPositioningSlider) {
            this.positionSliderAtSelected();
        }
    };

    // -----  ----- //

    return tzs_show;

}));

// lazyload
(function (window, factory) {
    // universal module definition
    /* jshint strict: false */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('tzs_show/js/lazyload', [
            './tzs_show',
            'fizzy-ui-utils/utils'
        ], function (tzs_show, utils) {
            return factory(window, tzs_show, utils);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('./tzs_show'),
            require('fizzy-ui-utils')
        );
    } else {
        // browser global
        factory(
            window,
            window.tzs_show,
            window.fizzyUIUtils
        );
    }

}(window, function factory(window, tzs_show, utils) {
    'use strict';

    tzs_show.createMethods.push('_createLazyload');
    let proto = tzs_show.prototype;

    proto._createLazyload = function () {
        this.on('select', this.lazyLoad);
    };

    proto.lazyLoad = function () {
        let lazyLoad = this.options.lazyLoad;
        if (!lazyLoad) {
            return;
        }
        // get adjacent cells, use lazyLoad option for adjacent count
        let adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
        let cellElems = this.getAdjacentCellElements(adjCount);
        // get lazy images in those cells
        let lazyImages = [];
        cellElems.forEach(function (cellElem) {
            let lazyCellImages = getCellLazyImages(cellElem);
            lazyImages = lazyImages.concat(lazyCellImages);
        });
        // load lazy images
        lazyImages.forEach(function (img) {
            new LazyLoader(img, this);
        }, this);
    };

    function getCellLazyImages(cellElem) {
        // check if cell element is lazy image
        if (cellElem.nodeName == 'IMG') {
            let lazyloadAttr = cellElem.getAttribute('data-tzs_show-lazyload');
            let srcAttr = cellElem.getAttribute('data-tzs_show-lazyload-src');
            let srcsetAttr = cellElem.getAttribute('data-tzs_show-lazyload-srcset');
            if (lazyloadAttr || srcAttr || srcsetAttr) {
                return [cellElem];
            }
        }
        // select lazy images in cell
        let lazySelector = 'img[data-tzs_show-lazyload], ' +
            'img[data-tzs_show-lazyload-src], img[data-tzs_show-lazyload-srcset]';
        let imgs = cellElem.querySelectorAll(lazySelector);
        return utils.makeArray(imgs);
    }

    // -------------------------- LazyLoader -------------------------- //

    /**
     * class to handle loading images
     */
    function LazyLoader(img, tzs_show) {
        this.img = img;
        this.tzs_show = tzs_show;
        this.load();
    }

    LazyLoader.prototype.handleEvent = utils.handleEvent;

    LazyLoader.prototype.load = function () {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        // get src & srcset
        let src = this.img.getAttribute('data-tzs_show-lazyload') ||
            this.img.getAttribute('data-tzs_show-lazyload-src');
        let srcset = this.img.getAttribute('data-tzs_show-lazyload-srcset');
        // set src & serset
        this.img.src = src;
        if (srcset) {
            this.img.setAttribute('srcset', srcset);
        }
        // remove attr
        this.img.removeAttribute('data-tzs_show-lazyload');
        this.img.removeAttribute('data-tzs_show-lazyload-src');
        this.img.removeAttribute('data-tzs_show-lazyload-srcset');
    };

    LazyLoader.prototype.onload = function (event) {
        this.complete(event, 'tzs_show-lazyloaded');
    };

    LazyLoader.prototype.onerror = function (event) {
        this.complete(event, 'tzs_show-lazyerror');
    };

    LazyLoader.prototype.complete = function (event, className) {
        // unbind events
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);

        let cell = this.tzs_show.getParentCell(this.img);
        let cellElem = cell && cell.element;
        this.tzs_show.cellSizeChange(cellElem);

        this.img.classList.add(className);
        this.tzs_show.dispatchEvent('lazyLoad', event, cellElem);
    };

    // -----  ----- //

    tzs_show.LazyLoader = LazyLoader;

    return tzs_show;

}));

/*!
 * tzs_show v2.2.1
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or tzs_show Commercial License for commercial use
 *
 * https://tzs_show.metafizzy.co
 * Copyright 2015-2019 Metafizzy
 */

(function (window, factory) {
    // universal module definition
    /* jshint strict: false */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('tzs_show/js/index', [
            './tzs_show',
            './drag',
            './prev-next-button',
            './page-dots',
            './player',
            './add-remove-cell',
            './lazyload'
        ], factory);
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('./tzs_show'),
            require('./drag'),
            require('./prev-next-button'),
            require('./page-dots'),
            require('./player'),
            require('./add-remove-cell'),
            require('./lazyload')
        );
    }

})(window, function factory(tzs_show) {
    /*jshint strict: false*/
    return tzs_show;
});

/*!
 * tzs_show asNavFor v2.0.2
 * enable asNavFor for tzs_show
 */

/*jshint browser: true, undef: true, unused: true, strict: true*/

(function (window, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('tzs_show-as-nav-for/as-nav-for', [
            'tzs_show/js/index',
            'fizzy-ui-utils/utils'
        ], factory);
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('tzs_show'),
            require('fizzy-ui-utils')
        );
    } else {
        // browser global
        window.tzs_show = factory(
            window.tzs_show,
            window.fizzyUIUtils
        );
    }

}(window, function factory(tzs_show, utils) {



    // -------------------------- asNavFor prototype -------------------------- //

    // tzs_show.defaults.asNavFor = null;

    tzs_show.createMethods.push('_createAsNavFor');

    let proto = tzs_show.prototype;

    proto._createAsNavFor = function () {
        this.on('activate', this.activateAsNavFor);
        this.on('deactivate', this.deactivateAsNavFor);
        this.on('destroy', this.destroyAsNavFor);

        let asNavForOption = this.options.asNavFor;
        if (!asNavForOption) {
            return;
        }
        // HACK do async, give time for other tzs_show to be initalized
        let _this = this;
        setTimeout(function initNavCompanion() {
            _this.setNavCompanion(asNavForOption);
        });
    };

    proto.setNavCompanion = function (elem) {
        elem = utils.getQueryElement(elem);
        let companion = tzs_show.data(elem);
        // stop if no companion or companion is self
        if (!companion || companion == this) {
            return;
        }

        this.navCompanion = companion;
        // companion select
        let _this = this;
        this.onNavCompanionSelect = function () {
            _this.navCompanionSelect();
        };
        companion.on('select', this.onNavCompanionSelect);
        // click
        this.on('staticClick', this.onNavStaticClick);

        this.navCompanionSelect(true);
    };

    proto.navCompanionSelect = function (isInstant) {
        // wait for companion & selectedCells first. #8
        let companionCells = this.navCompanion && this.navCompanion.selectedCells;
        if (!companionCells) {
            return;
        }
        // select slide that matches first cell of slide
        let selectedCell = companionCells[0];
        let firstIndex = this.navCompanion.cells.indexOf(selectedCell);
        let lastIndex = firstIndex + companionCells.length - 1;
        let selectIndex = Math.floor(lerp(firstIndex, lastIndex,
            this.navCompanion.cellAlign));
        this.selectCell(selectIndex, false, isInstant);
        // set nav selected class
        this.removeNavSelectedElements();
        // stop if companion has more cells than this one
        if (selectIndex >= this.cells.length) {
            return;
        }

        let selectedCells = this.cells.slice(firstIndex, lastIndex + 1);
        this.navSelectedElements = selectedCells.map(function (cell) {
            return cell.element;
        });
        this.changeNavSelectedClass('add');
    };

    function lerp(a, b, t) {
        return (b - a) * t + a;
    }

    proto.changeNavSelectedClass = function (method) {
        this.navSelectedElements.forEach(function (navElem) {
            navElem.classList[method]('is-nav-selected');
        });
    };

    proto.activateAsNavFor = function () {
        this.navCompanionSelect(true);
    };

    proto.removeNavSelectedElements = function () {
        if (!this.navSelectedElements) {
            return;
        }
        this.changeNavSelectedClass('remove');
        delete this.navSelectedElements;
    };

    proto.onNavStaticClick = function (event, pointer, cellElement, cellIndex) {
        if (typeof cellIndex == 'number') {
            this.navCompanion.selectCell(cellIndex);
        }
    };

    proto.deactivateAsNavFor = function () {
        this.removeNavSelectedElements();
    };

    proto.destroyAsNavFor = function () {
        if (!this.navCompanion) {
            return;
        }
        this.navCompanion.off('select', this.onNavCompanionSelect);
        this.off('staticClick', this.onNavStaticClick);
        delete this.navCompanion;
    };

    // -----  ----- //

    return tzs_show;

}));

/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

(function (window, factory) {
    'use strict';
    // universal module definition

    /*global define: false, module: false, require: false */

    if (typeof define == 'function' && define.amd) {
        // AMD
        define('imagesloaded/imagesloaded', [
            'ev-emitter/ev-emitter'
        ], function (EvEmitter) {
            return factory(window, EvEmitter);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('ev-emitter')
        );
    } else {
        // browser global
        window.imagesLoaded = factory(
            window,
            window.EvEmitter
        );
    }

})(typeof window !== 'undefined' ? window : this,

    // --------------------------  factory -------------------------- //

    function factory(window, EvEmitter) {



        let $ = awJq;
        let console = window.console;

        // -------------------------- helpers -------------------------- //

        // extend objects
        function extend(a, b) {
            for (let prop in b) {
                a[prop] = b[prop];
            }
            return a;
        }

        let arraySlice = Array.prototype.slice;

        // turn element or nodeList into an array
        function makeArray(obj) {
            if (Array.isArray(obj)) {
                // use object if already an array
                return obj;
            }

            let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
            if (isArrayLike) {
                // convert nodeList to array
                return arraySlice.call(obj);
            }

            // array of single index
            return [obj];
        }

        // -------------------------- imagesLoaded -------------------------- //

        /**
         * @param {Array, Element, NodeList, String} elem
         * @param {Object or Function} options - if function, use as callback
         * @param {Function} onAlways - callback function
         */
        function ImagesLoaded(elem, options, onAlways) {
            // coerce ImagesLoaded() without new, to be new ImagesLoaded()
            if (!(this instanceof ImagesLoaded)) {
                return new ImagesLoaded(elem, options, onAlways);
            }
            // use elem as selector string
            let queryElem = elem;
            if (typeof elem == 'string') {
                queryElem = document.querySelectorAll(elem);
            }
            // bail if bad element
            if (!queryElem) {
                console.error('Bad element for imagesLoaded ' + (queryElem || elem));
                return;
            }

            this.elements = makeArray(queryElem);
            this.options = extend({}, this.options);
            // shift arguments if no options set
            if (typeof options == 'function') {
                onAlways = options;
            } else {
                extend(this.options, options);
            }

            if (onAlways) {
                this.on('always', onAlways);
            }

            this.getImages();

            if ($) {
                // add jQuery Deferred object
                this.jqDeferred = new awJq.Deferred();
            }

            // HACK check async to allow time to bind listeners
            setTimeout(this.check.bind(this));
        }

        ImagesLoaded.prototype = Object.create(EvEmitter.prototype);

        ImagesLoaded.prototype.options = {};

        ImagesLoaded.prototype.getImages = function () {
            this.images = [];

            // filter & find items if we have an item selector
            this.elements.forEach(this.addElementImages, this);
        };

        /**
         * @param {Node} element
         */
        ImagesLoaded.prototype.addElementImages = function (elem) {
            // filter siblings
            if (elem.nodeName == 'IMG') {
                this.addImage(elem);
            }
            // get background image on element
            if (this.options.background === true) {
                this.addElementBackgroundImages(elem);
            }

            // find children
            // no non-element nodes, #143
            let nodeType = elem.nodeType;
            if (!nodeType || !elementNodeTypes[nodeType]) {
                return;
            }
            let childImgs = elem.querySelectorAll('img');
            // concat childElems to filterFound array
            for (let i = 0; i < childImgs.length; i++) {
                let img = childImgs[i];
                this.addImage(img);
            }

            // get child background images
            if (typeof this.options.background == 'string') {
                let children = elem.querySelectorAll(this.options.background);
                for (i = 0; i < children.length; i++) {
                    let child = children[i];
                    this.addElementBackgroundImages(child);
                }
            }
        };

        let elementNodeTypes = {
            1: true,
            9: true,
            11: true
        };

        ImagesLoaded.prototype.addElementBackgroundImages = function (elem) {
            let style = getComputedStyle(elem);
            if (!style) {
                // Firefox returns null if in a hidden iframe https://bugzil.la/548397
                return;
            }
            // get url inside url("...")
            let reURL = /url\((['"])?(.*?)\1\)/gi;
            let matches = reURL.exec(style.backgroundImage);
            while (matches !== null) {
                let url = matches && matches[2];
                if (url) {
                    this.addBackground(url, elem);
                }
                matches = reURL.exec(style.backgroundImage);
            }
        };

        /**
         * @param {Image} img
         */
        ImagesLoaded.prototype.addImage = function (img) {
            let loadingImage = new LoadingImage(img);
            this.images.push(loadingImage);
        };

        ImagesLoaded.prototype.addBackground = function (url, elem) {
            let background = new Background(url, elem);
            this.images.push(background);
        };

        ImagesLoaded.prototype.check = function () {
            let _this = this;
            this.progressedCount = 0;
            this.hasAnyBroken = false;
            // complete if no images
            if (!this.images.length) {
                this.complete();
                return;
            }

            function onProgress(image, elem, message) {
                // HACK - Chrome triggers event before object properties have changed. #83
                setTimeout(function () {
                    _this.progress(image, elem, message);
                });
            }

            this.images.forEach(function (loadingImage) {
                loadingImage.once('progress', onProgress);
                loadingImage.check();
            });
        };

        ImagesLoaded.prototype.progress = function (image, elem, message) {
            this.progressedCount++;
            this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
            // progress event
            this.emitEvent('progress', [this, image, elem]);
            if (this.jqDeferred && this.jqDeferred.notify) {
                this.jqDeferred.notify(this, image);
            }
            // check if completed
            if (this.progressedCount == this.images.length) {
                this.complete();
            }

            if (this.options.debug && console) {
                console.log('progress: ' + message, image, elem);
            }
        };

        ImagesLoaded.prototype.complete = function () {
            let eventName = this.hasAnyBroken ? 'fail' : 'done';
            this.isComplete = true;
            this.emitEvent(eventName, [this]);
            this.emitEvent('always', [this]);
            if (this.jqDeferred) {
                let jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
                this.jqDeferred[jqMethod](this);
            }
        };

        // --------------------------  -------------------------- //

        function LoadingImage(img) {
            this.img = img;
        }

        LoadingImage.prototype = Object.create(EvEmitter.prototype);

        LoadingImage.prototype.check = function () {
            // If complete is true and browser supports natural sizes,
            // try to check for image status manually.
            let isComplete = this.getIsImageComplete();
            if (isComplete) {
                // report based on naturalWidth
                this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
                return;
            }

            // If none of the checks above matched, simulate loading on detached element.
            this.proxyImage = new Image();
            this.proxyImage.addEventListener('load', this);
            this.proxyImage.addEventListener('error', this);
            // bind to image as well for Firefox. #191
            this.img.addEventListener('load', this);
            this.img.addEventListener('error', this);
            this.proxyImage.src = this.img.src;
        };

        LoadingImage.prototype.getIsImageComplete = function () {
            // check for non-zero, non-undefined naturalWidth
            // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
            return this.img.complete && this.img.naturalWidth;
        };

        LoadingImage.prototype.confirm = function (isLoaded, message) {
            this.isLoaded = isLoaded;
            this.emitEvent('progress', [this, this.img, message]);
        };

        // ----- events ----- //

        // trigger specified handler for event type
        LoadingImage.prototype.handleEvent = function (event) {
            let method = 'on' + event.type;
            if (this[method]) {
                this[method](event);
            }
        };

        LoadingImage.prototype.onload = function () {
            this.confirm(true, 'onload');
            this.unbindEvents();
        };

        LoadingImage.prototype.onerror = function () {
            this.confirm(false, 'onerror');
            this.unbindEvents();
        };

        LoadingImage.prototype.unbindEvents = function () {
            this.proxyImage.removeEventListener('load', this);
            this.proxyImage.removeEventListener('error', this);
            this.img.removeEventListener('load', this);
            this.img.removeEventListener('error', this);
        };

        // -------------------------- Background -------------------------- //

        function Background(url, element) {
            this.url = url;
            this.element = element;
            this.img = new Image();
        }

        // inherit LoadingImage prototype
        Background.prototype = Object.create(LoadingImage.prototype);

        Background.prototype.check = function () {
            this.img.addEventListener('load', this);
            this.img.addEventListener('error', this);
            this.img.src = this.url;
            // check if image is already complete
            let isComplete = this.getIsImageComplete();
            if (isComplete) {
                this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
                this.unbindEvents();
            }
        };

        Background.prototype.unbindEvents = function () {
            this.img.removeEventListener('load', this);
            this.img.removeEventListener('error', this);
        };

        Background.prototype.confirm = function (isLoaded, message) {
            this.isLoaded = isLoaded;
            this.emitEvent('progress', [this, this.element, message]);
        };

        // -------------------------- jQuery -------------------------- //

        ImagesLoaded.makeJQueryPlugin = function (_awJq) {
            // awJq = jQuery || window.jQuery;
            // if (!jQuery) {
            //   return;
            // }
            // set local letiable
            // $ = jQuery;
            // $().imagesLoaded()
            awJq.fn.imagesLoaded = function (options, callback) {
                let instance = new ImagesLoaded(this, options, callback);
                return instance.jqDeferred.promise(awJq(this));
            };
        };
        // try making plugin
        ImagesLoaded.makeJQueryPlugin();

        // --------------------------  -------------------------- //

        return ImagesLoaded;

    });

/*!
 * tzs_show imagesLoaded v2.0.0
 * enables imagesLoaded option for tzs_show
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

(function (window, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define([
            'tzs_show/js/index',
            'imagesloaded/imagesloaded'
        ], function (tzs_show, imagesLoaded) {
            return factory(window, tzs_show, imagesLoaded);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('tzs_show'),
            require('imagesloaded')
        );
    } else {
        // browser global
        window.tzs_show = factory(
            window,
            window.tzs_show,
            window.imagesLoaded
        );
    }

}(window, function factory(window, tzs_show, imagesLoaded) {
    'use strict';

    tzs_show.createMethods.push('_createImagesLoaded');

    let proto = tzs_show.prototype;

    proto._createImagesLoaded = function () {
        this.on('activate', this.imagesLoaded);
    };

    proto.imagesLoaded = function () {
        if (!this.options.imagesLoaded) {
            return;
        }
        let _this = this;
        function onImagesLoadedProgress(instance, image) {
            let cell = _this.getParentCell(image.img);
            _this.cellSizeChange(cell && cell.element);
            if (!_this.options.freeScroll) {
                _this.positionSliderAtSelected();
            }
        }
        imagesLoaded(this.slider).on('progress', onImagesLoadedProgress);
    };

    return tzs_show;

}));
